// Generated by AvenyModelEditor

import { IClientSubSystemModel } from '../../Types/ClientModelTypes';
import { TEDSelectionOperator as T} from '../../globalQueryTypes';

const OF: IClientSubSystemModel = {
  Code: 'OF',
  DisplayLabel: 'Order/Fakturering',
  BusinessModels: {
    OFArtradkontering: {
      CollectionName: 'OFArtradkontering',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'Artradkontering',
        Abstract: false,
        SOLabel: 'Kontering',
        SOGLabel: 'Kontering',
        SBLabel: 'Konteringen',
        SBGLabel: 'Konteringen',
        POLabel: 'Konteringar',
        POGLabel: 'Konteringar',
        PBLabel: 'Konteringarna',
        PBGLabel: 'Konteringarna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Konteringen primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Konteringen versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Konteringen id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Konteringen fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KPLAN_ID: {
          AttributeName: 'KPLAN_ID',
          DisplayLabel: 'Kontoplan',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ORDNINGS_NR_1: {
          AttributeName: 'ORDNINGS_NR_1',
          DisplayLabel: 'Ordningsnr 1',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KONTOID_1: {
          AttributeName: 'KONTOID_1',
          DisplayLabel: 'Kontoid 1',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ORDNINGS_NR_2: {
          AttributeName: 'ORDNINGS_NR_2',
          DisplayLabel: 'Ordningsnr 2',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KONTOID_2: {
          AttributeName: 'KONTOID_2',
          DisplayLabel: 'Kontoid 2',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ORDNINGS_NR_3: {
          AttributeName: 'ORDNINGS_NR_3',
          DisplayLabel: 'Ordningsnr 3',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KONTOID_3: {
          AttributeName: 'KONTOID_3',
          DisplayLabel: 'Kontoid 3',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ORDNINGS_NR_4: {
          AttributeName: 'ORDNINGS_NR_4',
          DisplayLabel: 'Ordningsnr 4',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KONTOID_4: {
          AttributeName: 'KONTOID_4',
          DisplayLabel: 'Kontoid 4',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ORDNINGS_NR_5: {
          AttributeName: 'ORDNINGS_NR_5',
          DisplayLabel: 'Ordningsnr 5',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KONTOID_5: {
          AttributeName: 'KONTOID_5',
          DisplayLabel: 'Kontoid 5',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ORDNINGS_NR_6: {
          AttributeName: 'ORDNINGS_NR_6',
          DisplayLabel: 'Ordningsnr 6',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KONTOID_6: {
          AttributeName: 'KONTOID_6',
          DisplayLabel: 'Kontoid 6',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ORDNINGS_NR_7: {
          AttributeName: 'ORDNINGS_NR_7',
          DisplayLabel: 'Ordningsnr 7',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KONTOID_7: {
          AttributeName: 'KONTOID_7',
          DisplayLabel: 'Kontoid 7',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ORDNINGS_NR_8: {
          AttributeName: 'ORDNINGS_NR_8',
          DisplayLabel: 'Ordningsnr 8',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KONTOID_8: {
          AttributeName: 'KONTOID_8',
          DisplayLabel: 'Kontoid 8',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ORDNINGS_NR_9: {
          AttributeName: 'ORDNINGS_NR_9',
          DisplayLabel: 'Ordningsnr 9',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KONTOID_9: {
          AttributeName: 'KONTOID_9',
          DisplayLabel: 'Kontoid 9',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ORDNINGS_NR_10: {
          AttributeName: 'ORDNINGS_NR_10',
          DisplayLabel: 'Ordningsnr 10',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KONTOID_10: {
          AttributeName: 'KONTOID_10',
          DisplayLabel: 'Kontoid 10',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        PROCENT: {
          AttributeName: 'PROCENT',
          DisplayLabel: 'Procent',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatIntAsPercent',
        },
        Kontoben: {
          AttributeName: 'Kontoben',
          DisplayLabel: 'Kontobenämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          Properties: new Map([['NO_CONDITION', 'Y;']]),
        },
        Kontostrang: {
          AttributeName: 'Kontostrang',
          DisplayLabel: 'Kontosträng',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          Properties: new Map([['NO_CONDITION', 'Y;']]),
        },
        Kontodel1: {
          AttributeName: 'Kontodel1',
          DisplayLabel: '@KONTO1@',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        Kontodel2: {
          AttributeName: 'Kontodel2',
          DisplayLabel: '@KONTO2@',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        Kontodel3: {
          AttributeName: 'Kontodel3',
          DisplayLabel: '@KONTO3@',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        Kontodel4: {
          AttributeName: 'Kontodel4',
          DisplayLabel: '@KONTO4@',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        Kontodel5: {
          AttributeName: 'Kontodel5',
          DisplayLabel: '@KONTO5@',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        Kontodel6: {
          AttributeName: 'Kontodel6',
          DisplayLabel: '@KONTO6@',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        Kontodel7: {
          AttributeName: 'Kontodel7',
          DisplayLabel: '@KONTO7@',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        Kontodel8: {
          AttributeName: 'Kontodel8',
          DisplayLabel: '@KONTO8@',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        Kontodel9: {
          AttributeName: 'Kontodel9',
          DisplayLabel: '@KONTO9@',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        Kontodel10: {
          AttributeName: 'Kontodel10',
          DisplayLabel: '@KONTO10@',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        Kontoben1: {
          AttributeName: 'Kontoben1',
          DisplayLabel: 'Kontoben1',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Kontoben2: {
          AttributeName: 'Kontoben2',
          DisplayLabel: 'Kontoben2',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Kontoben3: {
          AttributeName: 'Kontoben3',
          DisplayLabel: 'Kontoben3',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Kontoben4: {
          AttributeName: 'Kontoben4',
          DisplayLabel: 'Kontoben4',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Kontoben5: {
          AttributeName: 'Kontoben5',
          DisplayLabel: 'Kontoben5',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Kontoben6: {
          AttributeName: 'Kontoben6',
          DisplayLabel: 'Kontoben6',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Kontoben7: {
          AttributeName: 'Kontoben7',
          DisplayLabel: 'Kontoben7',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Kontoben8: {
          AttributeName: 'Kontoben8',
          DisplayLabel: 'Kontoben8',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Kontoben9: {
          AttributeName: 'Kontoben9',
          DisplayLabel: 'Kontoben9',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Kontoben10: {
          AttributeName: 'Kontoben10',
          DisplayLabel: 'Kontoben10',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Orderrad: {
          AssociationName: 'Orderrad',
          DisplayLabel: 'Orderrad',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'OFOrderrad',
          AssociatedComponentName: 'Orderrad',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    OFOrderBilaga: {
      CollectionName: 'OFOrderBilaga',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'OrderBilaga',
        Abstract: false,
        SOLabel: 'OrderBilaga',
        SOGLabel: 'OrderBilagas',
        SBLabel: 'OrderBilagan',
        SBGLabel: 'OrderBilagans',
        POLabel: 'OrderBilagor',
        POGLabel: 'OrderBilagors',
        PBLabel: 'OrderBilagorna',
        PBGLabel: 'OrderBilagornas',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'OrderBilagans primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'OrderBilagans versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'OrderBilagans fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ORDNINGS_NR: {
          AttributeName: 'ORDNINGS_NR',
          DisplayLabel: 'Orningsnummer',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        BILAGA_ID: {
          AttributeName: 'BILAGA_ID',
          DisplayLabel: 'Id, bilaga',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        KOPPLAD_I_RUTIN: {
          AttributeName: 'KOPPLAD_I_RUTIN',
          DisplayLabel: 'Kopplad i rutin',
          Hint: 'Order/Fakturera Gravskötsel/Fakturering',
          DataType: 'Enum',
          EnumValues: new Map([['ORDER', 'Order'], ['FAKTURERA_GRAVSKOTSEL', 'Fakturera Gravskötsel'], ['FAKTURERING', 'Fakturering']]),
          EnumSortValues: new Map([['ORDER', 'O'], ['FAKTURERA_GRAVSKOTSEL', 'G'], ['FAKTURERING', 'F']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="ORDER=Order;FAKTURERA_GRAVSKOTSEL=Fakturera Gravskötsel;FAKTURERING=Fakturering"',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          Required: true,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Order: {
          AssociationName: 'Order',
          DisplayLabel: 'Order',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'OFOrder',
          AssociatedComponentName: 'Order',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
          Required: true,
        },
        Bilaga: {
          AssociationName: 'Bilaga',
          DisplayLabel: 'Bilaga',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'KRExternprintbliaga',
          AssociatedComponentName: 'Externprintbliaga',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
          Required: true,
        },
      },
    },
    OFOrderintegrationBetalinfo: {
      CollectionName: 'OFOrderintegrationBetalinfo',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'OrderintegrationBetalinfo',
        Abstract: false,
        SOLabel: '',
        SOGLabel: '',
        SBLabel: '',
        SBGLabel: '',
        POLabel: '',
        POGLabel: '',
        PBLabel: '',
        PBGLabel: '',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'OFOrderintegrationBetalinfos primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'OFOrderintegrationBetalinfos versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'OFOrderintegrationBetalinfos fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BEHANDLING_STATUS: {
          AttributeName: 'BEHANDLING_STATUS',
          DisplayLabel: 'Behandling status',
          Hint: 'Mottagen/Klar/Felaktig',
          DataType: 'Enum',
          EnumValues: new Map([['MOTTAGEN', 'Mottagen'], ['KLAR', 'Klar'], ['FELAKTIG', 'Felaktig']]),
          EnumSortValues: new Map([['MOTTAGEN', '1'], ['KLAR', '2'], ['FELAKTIG', '3']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="MOTTAGEN=Mottagen;KLAR=Klar;FELAKTIG=Felaktig"',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          Required: true,
        },
        DATUM: {
          AttributeName: 'DATUM',
          DisplayLabel: 'DATUM',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        ORDERNUMBER: {
          AttributeName: 'ORDERNUMBER',
          DisplayLabel: 'ORDERNUMBER',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 20,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        CUSTOMER: {
          AttributeName: 'CUSTOMER',
          DisplayLabel: 'CUSTOMER',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 20,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        INVOICENUMBER: {
          AttributeName: 'INVOICENUMBER',
          DisplayLabel: 'INVOICENUMBER',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 20,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        INVOICETYPE: {
          AttributeName: 'INVOICETYPE',
          DisplayLabel: 'INVOICETYPE',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 1,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        PAID: {
          AttributeName: 'PAID',
          DisplayLabel: 'PAID',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 1,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        INVOICEDATE: {
          AttributeName: 'INVOICEDATE',
          DisplayLabel: 'INVOICEDATE',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        PAYMENTDATE: {
          AttributeName: 'PAYMENTDATE',
          DisplayLabel: 'PAYMENTDATE',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        DUEDATE: {
          AttributeName: 'DUEDATE',
          DisplayLabel: 'DUEDATE',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        INVOICEAMOUNT: {
          AttributeName: 'INVOICEAMOUNT',
          DisplayLabel: 'INVOICEAMOUNT',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        PAIDAMOUNT: {
          AttributeName: 'PAIDAMOUNT',
          DisplayLabel: 'PAIDAMOUNT',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        STATUS: {
          AttributeName: 'STATUS',
          DisplayLabel: 'STATUS',
          Hint: 'Faktura skickad till kund/Förfallen/Påminnelse skickad/Påminnelse2 skickad/Påminnelse3 skickad/Skickad till inkasso/Fullt betald/Delvis betald/Överbetalning registrerad/Kreditfaktura utfärdad/Annullerad',
          DataType: 'Enum',
          EnumValues: new Map([['FAKTURA_SKICKAD_TILL_KUND', 'Faktura skickad till kund'], ['FORFALLEN', 'Förfallen'], ['PAMINNELSE_SKICKAD', 'Påminnelse skickad'], ['PAMINNELSE2_SKICKAD', 'Påminnelse2 skickad'], ['PAMINNELSE3_SKICKAD', 'Påminnelse3 skickad'], ['SKICKAD_TILL_INKASSO', 'Skickad till inkasso'], ['FULLT_BETALD', 'Fullt betald'], ['DELVIS_BETALD', 'Delvis betald'], ['OVERBETALNING_REGISTRERAD', 'Överbetalning registrerad'], ['KREDITFAKTURA_UTFARDAD', 'Kreditfaktura utfärdad'], ['ANNULLERAD', 'Annullerad']]),
          EnumSortValues: new Map([['FAKTURA_SKICKAD_TILL_KUND', 'sent_to_customer'], ['FORFALLEN', 'overdue'], ['PAMINNELSE_SKICKAD', 'reminder'], ['PAMINNELSE2_SKICKAD', 'reminder2'], ['PAMINNELSE3_SKICKAD', 'reminder3'], ['SKICKAD_TILL_INKASSO', 'debt_collection'], ['FULLT_BETALD', 'paid'], ['DELVIS_BETALD', 'partly_paid'], ['OVERBETALNING_REGISTRERAD', 'over_paid'], ['KREDITFAKTURA_UTFARDAD', 'credited'], ['ANNULLERAD', 'cancelled']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="FAKTURA_SKICKAD_TILL_KUND=Faktura skickad till kund;FORFALLEN=Förfallen;PAMINNELSE_SKICKAD=Påminnelse skickad;PAMINNELSE2_SKICKAD=Påminnelse2 skickad;PAMINNELSE3_SKICKAD=Påminnelse3 skickad;SKICKAD_TILL_INKASSO=Skickad till inkasso;FULLT_BETALD=Fullt betald;DELVIS_BETALD=Delvis betald;OVERBETALNING_REGISTRERAD=Överbetalning registrerad;KREDITFAKTURA_UTFARDAD=Kreditfaktura utfärdad;ANNULLERAD=Annullerad"',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        ATTACHMENTURL: {
          AttributeName: 'ATTACHMENTURL',
          DisplayLabel: 'ATTACHMENTURL',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 255,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
      },
      Associations: {
      },
    },
    OFOrderkategori: {
      CollectionName: 'OFOrderkategori',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'Orderkategori',
        Abstract: false,
        SOLabel: 'Orderkategori',
        SOGLabel: 'Orderkategori',
        SBLabel: 'Orderkategorin',
        SBGLabel: 'Orderkategorin',
        POLabel: 'Orderkategorier',
        POGLabel: 'Orderkategorier',
        PBLabel: 'Orderkategorierna',
        PBGLabel: 'Orderkategorierna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Orderkategorin primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Orderkategorin versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Orderkategorin id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Orderkategorin fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BENAMNING: {
          AttributeName: 'BENAMNING',
          DisplayLabel: 'Benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          Required: true,
        },
        KBIntaktskonto: {
          AttributeName: 'KBIntaktskonto',
          DisplayLabel: 'KBIntaktskonto',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Intaktskonto: {
          AttributeName: 'Intaktskonto',
          DisplayLabel: 'Intäktskonto',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          Properties: new Map([['NO_CONDITION', 'Y;']]),
        },
        RuleID: {
          AttributeName: 'RuleID',
          DisplayLabel: 'RuleID',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Intaktskonto: {
          AssociationName: 'Intaktskonto',
          DisplayLabel: 'Intäktskonto',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'EKKonteringsvarde',
          AssociatedComponentName: 'Konteringsvarde',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    OFOrderMoms: {
      CollectionName: 'OFOrderMoms',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'Ordermoms',
        Abstract: false,
        SOLabel: 'Ordermoms',
        SOGLabel: 'Ordermoms',
        SBLabel: 'Ordermoms',
        SBGLabel: 'Ordermoms',
        POLabel: 'Ordermomser',
        POGLabel: 'Ordermomsers',
        PBLabel: 'Ordermomserna',
        PBGLabel: 'Ordermomsernas',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Ordermoms primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Ordermoms versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Ordermoms fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ORDER_ID: {
          AttributeName: 'ORDER_ID',
          DisplayLabel: 'Orderid',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        LOPNR: {
          AttributeName: 'LOPNR',
          DisplayLabel: 'Löpnr',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        MOMS_ID: {
          AttributeName: 'MOMS_ID',
          DisplayLabel: 'Momsid',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        MOMS_BELOPP: {
          AttributeName: 'MOMS_BELOPP',
          DisplayLabel: 'Momsbelopp',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        BASERAT_PA_BELOPP: {
          AttributeName: 'BASERAT_PA_BELOPP',
          DisplayLabel: 'Baserat på belopp',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatCurr',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Moms: {
          AssociationName: 'Moms',
          DisplayLabel: 'Moms',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'SYSMoms',
          AssociatedComponentName: 'Moms',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    OFOrderrad: {
      CollectionName: 'OFOrderrad',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([['USER_DEF_REPORT_ROUTINE', '4010']]),
      RootType: {
        TypeValue: 'Orderrad',
        Abstract: true,
        SOLabel: 'Orderrad',
        SOGLabel: 'Orderrad',
        SBLabel: 'Orderraden',
        SBGLabel: 'Orderraden',
        POLabel: 'Orderrader',
        POGLabel: 'Orderrader',
        PBLabel: 'Orderraderna',
        PBGLabel: 'Orderraderna',
        Visible: true,
        ChildTypes: [
          {
            TypeValue: 'Textrad',
            Abstract: false,
            SOLabel: 'Fakturatext',
            SOGLabel: 'Fakturatext',
            SBLabel: 'Fakturatexten',
            SBGLabel: 'Fakturatexten',
            POLabel: 'Fakturatexter',
            POGLabel: 'Fakturatexter',
            PBLabel: 'Fakturatexterna',
            PBGLabel: 'Fakturatexterna',
            Visible: true,
            ChildTypes: [
            ],
          },
          {
            TypeValue: 'Artikelrad',
            Abstract: false,
            SOLabel: 'Artikelrad',
            SOGLabel: 'Artikelrad',
            SBLabel: 'Artikelraden',
            SBGLabel: 'Artikelraden',
            POLabel: 'Artikelrader',
            POGLabel: 'Artikelrader',
            PBLabel: 'Artikelraderna',
            PBGLabel: 'Artikelraderna',
            Visible: true,
            ChildTypes: [
            ],
          },
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Orderraden primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Orderraden versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _typ: {
          AttributeName: '_typ',
          DisplayLabel: 'Typ',
          DataType: 'Enum',
          EnumValues: new Map([['TEXTRAD', 'Fakturatext'], ['ARTIKELRAD', 'Artikelrad']]),
          EnumSortValues: new Map([['TEXTRAD', 'T'], ['ARTIKELRAD', 'A']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifTypeTree',
          Required: true,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Orderraden id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Orderraden fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ORDERRADNR: {
          AttributeName: 'ORDERRADNR',
          DisplayLabel: 'Orderradnummer',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        BENAMNING: {
          AttributeName: 'BENAMNING',
          DisplayLabel: 'Benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        ORDNINGSNR: {
          AttributeName: 'ORDNINGSNR',
          DisplayLabel: 'Ordningsnummer',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
        },
        STATUS: {
          AttributeName: 'STATUS',
          DisplayLabel: 'Status',
          Hint: 'Registrerad/Delfakturerad/Slutfakturerad/Fakturerad/Restnoterad',
          DataType: 'Enum',
          EnumValues: new Map([['REGISTRERAD', 'Registrerad'], ['DELFAKTURERAD', 'Delfakturerad'], ['SLUTFAKTURERAD', 'Slutfakturerad'], ['FAKTURERAD', 'Fakturerad'], ['RESTNOTERAD', 'Restnoterad']]),
          EnumSortValues: new Map([['REGISTRERAD', 'R'], ['DELFAKTURERAD', 'D'], ['SLUTFAKTURERAD', 'S'], ['FAKTURERAD', 'F'], ['RESTNOTERAD', 'E']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="REGISTRERAD=Registrerad;DELFAKTURERAD=Delfakturerad;SLUTFAKTURERAD=Slutfakturerad;FAKTURERAD=Fakturerad;RESTNOTERAD=Restnoterad"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
        },
        FD_STATUS: {
          AttributeName: 'FD_STATUS',
          DisplayLabel: 'Fd status',
          Hint: 'Slutfakturerad/Registrerad/Restnoterad/Delfakturerad/Fakturerad',
          DataType: 'Enum',
          EnumValues: new Map([['SLUTFAKTURERAD', 'Slutfakturerad'], ['REGISTRERAD', 'Registrerad'], ['RESTNOTERAD', 'Restnoterad'], ['DELFAKTURERAD', 'Delfakturerad'], ['FAKTURERAD', 'Fakturerad']]),
          EnumSortValues: new Map([['SLUTFAKTURERAD', 'S'], ['REGISTRERAD', 'R'], ['RESTNOTERAD', 'E'], ['DELFAKTURERAD', 'D'], ['FAKTURERAD', 'F']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SLUTFAKTURERAD=Slutfakturerad;REGISTRERAD=Registrerad;RESTNOTERAD=Restnoterad;DELFAKTURERAD=Delfakturerad;FAKTURERAD=Fakturerad"',
        },
        FAKTURA: {
          AttributeName: 'FAKTURA',
          DisplayLabel: 'Kommer med på faktura',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
          FormatterParseParams: 'FalseText="Nej";TrueText="Ja"',
          FormatterDisplayParams: 'FalseText="Nej";TrueText="Ja"',
          GUIEditable: true,
        },
        ArtNrFaktText: {
          AttributeName: 'ArtNrFaktText',
          DisplayLabel: 'Artikelnummer/Fakturatext',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        TrimBenamning: {
          AttributeName: 'TrimBenamning',
          DisplayLabel: 'Trimbenamning',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FaktGrupp: {
          AttributeName: 'FaktGrupp',
          DisplayLabel: 'Faktureringsgrupp',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Kundnamn: {
          AttributeName: 'Kundnamn',
          DisplayLabel: 'Kundnamn',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Kundnr: {
          AttributeName: 'Kundnr',
          DisplayLabel: 'Kundnr',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Ordernr: {
          AttributeName: 'Ordernr',
          DisplayLabel: 'Ordernr',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Kreditorder: {
          AttributeName: 'Kreditorder',
          DisplayLabel: 'Kreditorder',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
        },
        FaktGruppID: {
          AttributeName: 'FaktGruppID',
          DisplayLabel: 'FaktGruppID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Fakturanr: {
          AttributeName: 'Fakturanr',
          DisplayLabel: 'Fakturanummer',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        ArtikelTextgrupp: {
          AttributeName: 'ArtikelTextgrupp',
          DisplayLabel: 'Artikelgrupp/Textgrupp',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        Orderdatum: {
          AttributeName: 'Orderdatum',
          DisplayLabel: 'Orderdatum',
          DataType: 'DateTime',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatDate',
        },
        Leveransdatum: {
          AttributeName: 'Leveransdatum',
          DisplayLabel: 'Leveransdatum',
          DataType: 'DateTime',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatDate',
        },
        KundkategoriKod: {
          AttributeName: 'KundkategoriKod',
          DisplayLabel: 'Kundkategorikod',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Slutfakturadatum: {
          AttributeName: 'Slutfakturadatum',
          DisplayLabel: 'Slutfakturadatum',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        Kundkategori: {
          AttributeName: 'Kundkategori',
          DisplayLabel: 'Kundkategori',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        SortArtnrFakttext: {
          AttributeName: 'SortArtnrFakttext',
          DisplayLabel: 'Artikelnr',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FAKTURATEXT_ID: {
          AttributeName: 'FAKTURATEXT_ID',
          DisplayLabel: 'Fakturatext',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['Textrad'],
        },
        ORDERBEKRAFTELSE: {
          AttributeName: 'ORDERBEKRAFTELSE',
          DisplayLabel: 'Kommer med på orderbekräftelse',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
          FormatterParseParams: 'FalseText="Nej";TrueText="Ja"',
          FormatterDisplayParams: 'FalseText="Nej";TrueText="Ja"',
          GUIEditable: true,
          ValidInComps: ['Textrad'],
        },
        ARBETSORDER: {
          AttributeName: 'ARBETSORDER',
          DisplayLabel: 'Kommer med på arbetsordern',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
          FormatterParseParams: 'FalseText="Nej";TrueText="Ja"',
          FormatterDisplayParams: 'FalseText="Nej";TrueText="Ja"',
          GUIEditable: true,
          ValidInComps: ['Textrad'],
        },
        SKRIVSTATUS: {
          AttributeName: 'SKRIVSTATUS',
          DisplayLabel: 'Skrivstatus',
          Hint: 'Fet stil',
          DataType: 'Enum',
          EnumValues: new Map([['FET_STIL', 'Fet stil']]),
          EnumSortValues: new Map([['FET_STIL', 'F']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="FET_STIL=Fet stil"',
          ValidInComps: ['Textrad'],
        },
        MOMS_ID: {
          AttributeName: 'MOMS_ID',
          DisplayLabel: 'Moms ID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['Artikelrad'],
        },
        ARTIKEL_ID: {
          AttributeName: 'ARTIKEL_ID',
          DisplayLabel: 'Artikel',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['Artikelrad'],
        },
        APRIS: {
          AttributeName: 'APRIS',
          DisplayLabel: 'À-pris',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatCurr',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          ValidInComps: ['Artikelrad'],
        },
        RABATT: {
          AttributeName: 'RABATT',
          DisplayLabel: 'Rabatt',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatIntAsPercent',
          FormatterDisplayParams: 'Decimals="0"',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          ValidInComps: ['Artikelrad'],
        },
        BESTANTAL: {
          AttributeName: 'BESTANTAL',
          DisplayLabel: 'Beställt antal',
          DataType: 'Float',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatFloat',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          ValidInComps: ['Artikelrad'],
        },
        LEVANTAL: {
          AttributeName: 'LEVANTAL',
          DisplayLabel: 'Levererat antal',
          DataType: 'Float',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatFloat',
          FormatterValidateParams: 'MinValue="0"',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          ValidInComps: ['Artikelrad'],
        },
        ANTAL_ATT_FAKT: {
          AttributeName: 'ANTAL_ATT_FAKT',
          DisplayLabel: 'Antal att fakturera',
          DataType: 'Float',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatFloat',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          ValidInComps: ['Artikelrad'],
        },
        SLUTLEVERERAD: {
          AttributeName: 'SLUTLEVERERAD',
          DisplayLabel: 'Slutlevererad',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          FormatterParseParams: 'FalseText="Nej";TrueText="Ja"',
          FormatterDisplayParams: 'FalseText="Nej";TrueText="Ja"',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          ValidInComps: ['Artikelrad'],
        },
        ATTFAKTURERABELOPP: {
          AttributeName: 'ATTFAKTURERABELOPP',
          DisplayLabel: 'Belopp att fakturera',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          ValidInComps: ['Artikelrad'],
          Properties: new Map([['ffIgnoreChanges', 'Y']]),
        },
        BESTALLTBELOPP: {
          AttributeName: 'BESTALLTBELOPP',
          DisplayLabel: 'Beställt belopp',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          ValidInComps: ['Artikelrad'],
          Properties: new Map([['ffIgnoreChanges', 'Y']]),
        },
        ENHET_ID: {
          AttributeName: 'ENHET_ID',
          DisplayLabel: 'Enhet',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['Artikelrad'],
        },
        STARTDATUM: {
          AttributeName: 'STARTDATUM',
          DisplayLabel: 'Startmånad',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDateMonth',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          ValidInComps: ['Artikelrad'],
          AttributeGroup: 'Övrigt',
        },
        NASTADATUM: {
          AttributeName: 'NASTADATUM',
          DisplayLabel: 'Nästa faktureringsmånad',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDateMonth',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          ValidInComps: ['Artikelrad'],
          AttributeGroup: 'Övrigt',
        },
        SLUTDATUM: {
          AttributeName: 'SLUTDATUM',
          DisplayLabel: 'Slutmånad',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDateMonth',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          ValidInComps: ['Artikelrad'],
          AttributeGroup: 'Övrigt',
        },
        ANTAL_MAN: {
          AttributeName: 'ANTAL_MAN',
          DisplayLabel: 'Antal månader',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          ValidInComps: ['Artikelrad'],
          AttributeGroup: 'Övrigt',
        },
        FDAPRIS: {
          AttributeName: 'FDAPRIS',
          DisplayLabel: 'fd à-pris',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          ValidInComps: ['Artikelrad'],
        },
        PRISUPPDATERING_DATUM: {
          AttributeName: 'PRISUPPDATERING_DATUM',
          DisplayLabel: 'Prisuppdateringsdatum',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          ValidInComps: ['Artikelrad'],
        },
        EJ_MANAD: {
          AttributeName: 'EJ_MANAD',
          DisplayLabel: 'Ej månad',
          Hint: 'Antal multipliceras ej med antal månader - Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          FormatterParseParams: 'FalseText="Nej";TrueText="Ja"',
          FormatterDisplayParams: 'FalseText="Nej";TrueText="Ja"',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          ValidInComps: ['Artikelrad'],
        },
        AVR_JUSTERING: {
          AttributeName: 'AVR_JUSTERING',
          DisplayLabel: 'Avräkning, justering',
          DataType: 'Currency',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['Artikelrad'],
        },
        DOLJ_BELOPP: {
          AttributeName: 'DOLJ_BELOPP',
          DisplayLabel: 'Dölj belopp',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
          ValidInComps: ['Artikelrad'],
        },
        RANTEFAKT_GRUPP_ID: {
          AttributeName: 'RANTEFAKT_GRUPP_ID',
          DisplayLabel: 'Grupp, räntefaktura',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['Artikelrad'],
        },
        RANTEFAKT_ID: {
          AttributeName: 'RANTEFAKT_ID',
          DisplayLabel: 'Id, räntefaktura',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['Artikelrad'],
        },
        RadBelopp: {
          AttributeName: 'RadBelopp',
          DisplayLabel: 'Belopp',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          ValidInComps: ['Artikelrad'],
        },
        Artikelnr: {
          AttributeName: 'Artikelnr',
          DisplayLabel: 'Artikelnr',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          ValidInComps: ['Artikelrad'],
        },
        EnhetAntalDec: {
          AttributeName: 'EnhetAntalDec',
          DisplayLabel: 'EnhetantalDec',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['Artikelrad'],
        },
        KvarAttLev: {
          AttributeName: 'KvarAttLev',
          DisplayLabel: 'Kvar att leverera',
          DataType: 'Float',
          Attribute: 'Normal',
          Condition: 'None',
          ValidInComps: ['Artikelrad'],
        },
        Enhet: {
          AttributeName: 'Enhet',
          DisplayLabel: 'Enhet',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          ValidInComps: ['Artikelrad'],
        },
        Artikeltyp: {
          AttributeName: 'Artikeltyp',
          DisplayLabel: 'Artikeltyp',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['Artikelrad'],
        },
        RadBelopp2: {
          AttributeName: 'RadBelopp2',
          DisplayLabel: 'Radbelopp2',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'None',
          ValidInComps: ['Artikelrad'],
        },
        ArtikelMomsID: {
          AttributeName: 'ArtikelMomsID',
          DisplayLabel: 'Artikelns moms ID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['Artikelrad'],
        },
        EjRadRabatt: {
          AttributeName: 'EjRadRabatt',
          DisplayLabel: 'Artikel - ej rabatt',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          ValidInComps: ['Artikelrad'],
        },
        ArtikelNr2: {
          AttributeName: 'ArtikelNr2',
          DisplayLabel: 'Artikelnr',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['Artikelrad'],
        },
        Kontostrang: {
          AttributeName: 'Kontostrang',
          DisplayLabel: 'Intäktskonto',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          ValidInComps: ['Artikelrad'],
        },
        Kontoben: {
          AttributeName: 'Kontoben',
          DisplayLabel: 'Kontobenämning',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['Artikelrad'],
        },
        Sortiment: {
          AttributeName: 'Sortiment',
          DisplayLabel: 'Sortiment',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['Artikelrad'],
        },
        Andra_Antal: {
          AttributeName: 'Andra_Antal',
          DisplayLabel: 'Ändra antal',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['Artikelrad'],
        },
        Andra_Pris: {
          AttributeName: 'Andra_Pris',
          DisplayLabel: 'Ändra pris (KOB-artikel)',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['Artikelrad'],
        },
        MOMS_BELOPP: {
          AttributeName: 'MOMS_BELOPP',
          DisplayLabel: 'Momsbelopp',
          DataType: 'Currency',
          Attribute: 'Internal',
          Condition: 'None',
        },
        IMPORT_ARTIKELNR: {
          AttributeName: 'IMPORT_ARTIKELNR',
          DisplayLabel: 'Import artikelnummer',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          AttributeGroup: 'Sveorder',
        },
        KOB_ARTIKELNR: {
          AttributeName: 'KOB_ARTIKELNR',
          DisplayLabel: 'KOB, artikelnr',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 12,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Sveorder',
        },
        RABATT_I_KR: {
          AttributeName: 'RABATT_I_KR',
          DisplayLabel: 'Rabatt i kr',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        Slutfakturadatum2: {
          AttributeName: 'Slutfakturadatum2',
          DisplayLabel: 'Fakt dat',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        MomsBelopp: {
          AttributeName: 'MomsBelopp',
          DisplayLabel: 'Momsbelopp',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'None',
        },
        BeloppInklMoms: {
          AttributeName: 'BeloppInklMoms',
          DisplayLabel: 'Belopp inkl moms',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        PERIODMALL_RAD_AVSLUTAD: {
          AttributeName: 'PERIODMALL_RAD_AVSLUTAD',
          DisplayLabel: 'Rad för periodmall, avslutad',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Övrigt',
        },
        PERIODISERAD: {
          AttributeName: 'PERIODISERAD',
          DisplayLabel: 'Periodiserad',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        PERIODISERAD_PERIOD_FRAN: {
          AttributeName: 'PERIODISERAD_PERIOD_FRAN',
          DisplayLabel: 'Periodiserad, period fr o m',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDateMonth',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        PERIODISERAD_PERIOD_TILL: {
          AttributeName: 'PERIODISERAD_PERIOD_TILL',
          DisplayLabel: 'Periodiserad, period t o m',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDateMonth',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        PERIODMALL_UPPDATERA_PRISER: {
          AttributeName: 'PERIODMALL_UPPDATERA_PRISER',
          DisplayLabel: 'Periodmall, använd aktuella priser',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Övrigt',
        },
        BACKINFO_STATUS: {
          AttributeName: 'BACKINFO_STATUS',
          DisplayLabel: 'Backningsinfo, status',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        BACKINFO_FD_STATUS: {
          AttributeName: 'BACKINFO_FD_STATUS',
          DisplayLabel: 'Backningsinfo, fd status',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        BACKINFO_NASTADATUM: {
          AttributeName: 'BACKINFO_NASTADATUM',
          DisplayLabel: 'Backningsinfo, nästa datum',
          DataType: 'Date',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        BACKINFO_ORDERRADNR: {
          AttributeName: 'BACKINFO_ORDERRADNR',
          DisplayLabel: 'Backningsinfo orderradnr',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        BACKINFO_ARTIKEL_ID: {
          AttributeName: 'BACKINFO_ARTIKEL_ID',
          DisplayLabel: 'Backningsinfo, artikelid',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
      },
      Associations: {
        Ordern: {
          AssociationName: 'Ordern',
          DisplayLabel: 'Order',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'OFOrder',
          AssociatedComponentName: 'Order',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Fakturarad: {
          AssociationName: 'Fakturarad',
          DisplayLabel: 'Fakturarad',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'KRFakturarad',
          AssociatedComponentName: 'Fakturarad',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        DrojRantafaktura: {
          AssociationName: 'DrojRantafaktura',
          DisplayLabel: 'DröjRäntafaktura',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'KRFaktura',
          AssociatedComponentName: 'Faktura',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Fakturatext: {
          AssociationName: 'Fakturatext',
          DisplayLabel: 'Fakturatext',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'LAFakturatext',
          AssociatedComponentName: 'Fakturatext',
          JoinAssociation: true,
          ValidInComps: ['Textrad'],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Moms: {
          AssociationName: 'Moms',
          DisplayLabel: 'Moms',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'SYSMoms',
          AssociatedComponentName: 'Moms',
          JoinAssociation: true,
          ValidInComps: ['Artikelrad'],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Artikel: {
          AssociationName: 'Artikel',
          DisplayLabel: 'Artikel',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'LAArtikel',
          AssociatedComponentName: 'Artikel',
          JoinAssociation: true,
          ValidInComps: ['Artikelrad'],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Enhet: {
          AssociationName: 'Enhet',
          DisplayLabel: 'Enhet',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'LAEnhet',
          AssociatedComponentName: 'Enhet',
          JoinAssociation: true,
          ValidInComps: ['Artikelrad'],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Kontering: {
          AssociationName: 'Kontering',
          DisplayLabel: 'Kontering',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'OFArtradkontering',
          AssociatedComponentName: 'Artradkontering',
          JoinAssociation: false,
          ValidInComps: ['Artikelrad'],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    OFOrderunderlag: {
      CollectionName: 'OFOrderunderlag',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'Orderunderlag',
        Abstract: false,
        SOLabel: 'Orderunderlag',
        SOGLabel: 'Orderunderlag',
        SBLabel: 'Orderunderlaget',
        SBGLabel: 'Orderunderlaget',
        POLabel: 'Orderunderlag',
        POGLabel: 'Orderunderlag',
        PBLabel: 'Orderunderlagen',
        PBGLabel: 'Orderunderlagen',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Orderunderlaget primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Orderunderlaget versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Orderunderlaget id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Orderunderlaget fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FIL_DATUM: {
          AttributeName: 'FIL_DATUM',
          DisplayLabel: 'Datum i fil',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        FIL_LOPNR: {
          AttributeName: 'FIL_LOPNR',
          DisplayLabel: 'Löpnummer i fil',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatInt',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        FIL_NAMN: {
          AttributeName: 'FIL_NAMN',
          DisplayLabel: 'Filnamn',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 250,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        STATUS: {
          AttributeName: 'STATUS',
          DisplayLabel: 'Status',
          Hint: 'Skapad/Backad',
          DataType: 'Enum',
          EnumValues: new Map([['SKAPAD', 'Skapad'], ['BACKAD', 'Backad']]),
          EnumSortValues: new Map([['SKAPAD', 'S'], ['BACKAD', 'B']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SKAPAD=Skapad;BACKAD=Backad"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          Required: true,
        },
        DATUM_SKAPAD: {
          AttributeName: 'DATUM_SKAPAD',
          DisplayLabel: 'Skapad datum',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        SIGN_SKAPAD: {
          AttributeName: 'SIGN_SKAPAD',
          DisplayLabel: 'Skapad av',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        DATUM_BACKAD: {
          AttributeName: 'DATUM_BACKAD',
          DisplayLabel: 'Backad datum',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        SIGN_BACKAD: {
          AttributeName: 'SIGN_BACKAD',
          DisplayLabel: 'Backad av',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        IMPORTTYP: {
          AttributeName: 'IMPORTTYP',
          DisplayLabel: 'Importtyp',
          Hint: 'Sveorder/Eniac-format',
          DataType: 'Enum',
          EnumValues: new Map([['SVEORDER', 'Sveorder'], ['ENIAC_FORMAT', 'Eniac-format']]),
          EnumSortValues: new Map([['SVEORDER', 'S'], ['ENIAC_FORMAT', 'E']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SVEORDER=Sveorder;ENIAC_FORMAT=Eniac-format"',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        XML: {
          AttributeName: 'XML',
          DisplayLabel: 'XML',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNone',
        },
        ORDERMOTTAGNINGSVAG_ID: {
          AttributeName: 'ORDERMOTTAGNINGSVAG_ID',
          DisplayLabel: 'Id, ordermottagningsväg',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        FELLOGG: {
          AttributeName: 'FELLOGG',
          DisplayLabel: 'Logg över felaktiga borttagna order',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNone',
        },
        HarFellogg: {
          AttributeName: 'HarFellogg',
          DisplayLabel: 'Har fellogg',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          InterfaceType: 'ifBoolean',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Ordermottagningsvag: {
          AssociationName: 'Ordermottagningsvag',
          DisplayLabel: 'Ordermottagningsväg',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'SYSOrdermottagningsvag',
          AssociatedComponentName: 'Ordermottagningsvag',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Ordrar: {
          AssociationName: 'Ordrar',
          DisplayLabel: 'Ordrar',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'OFOrder',
          AssociatedComponentName: 'Order',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    OFOrder: {
      CollectionName: 'OFOrder',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([['GroupAssociation', 'Grupp'], ['USER_DEF_REPORT_ROUTINE', '4001'], ['AllowEdit', '22001']]),
      RootType: {
        TypeValue: 'Order',
        Abstract: true,
        SOLabel: 'Order',
        SOGLabel: 'Order',
        SBLabel: 'Ordern',
        SBGLabel: 'Ordern',
        POLabel: 'Ordrar',
        POGLabel: 'Ordrar',
        PBLabel: 'Ordrarna',
        PBGLabel: 'Ordrarna',
        Visible: true,
        ChildTypes: [
          {
            TypeValue: 'Direktorder',
            Abstract: false,
            SOLabel: 'Direktorder',
            SOGLabel: 'Direktorder',
            SBLabel: 'Direktordern',
            SBGLabel: 'Direktordern',
            POLabel: 'Direktordrar',
            POGLabel: 'Direktordrar',
            PBLabel: 'Direktordrarna',
            PBGLabel: 'Direktordrarna',
            Visible: true,
            ChildTypes: [
            ],
          },
          {
            TypeValue: 'Erbjudande',
            Abstract: false,
            SOLabel: 'Erbjudande',
            SOGLabel: 'Erbjudande',
            SBLabel: 'Erbjudandet',
            SBGLabel: 'Erbjudandet',
            POLabel: 'Erbjudande',
            POGLabel: 'Erbjudande',
            PBLabel: 'Erbjudanden',
            PBGLabel: 'Erbjudanden',
            Visible: true,
            ChildTypes: [
            ],
          },
          {
            TypeValue: 'BestOrder',
            Abstract: false,
            SOLabel: 'Beställningsorder',
            SOGLabel: 'Beställningsorders',
            SBLabel: 'Beställningsordern',
            SBGLabel: 'Beställningsorderns',
            POLabel: 'Beställningsordrar',
            POGLabel: 'Beställningsordrars',
            PBLabel: 'Beställningsordrarna',
            PBGLabel: 'Beställningsordrarnas',
            Visible: true,
            ChildTypes: [
            ],
          },
          {
            TypeValue: 'AvrakningKundavtal',
            Abstract: false,
            SOLabel: 'Avräkning',
            SOGLabel: 'Avräkning',
            SBLabel: 'Avräkningen',
            SBGLabel: 'Avräkningen',
            POLabel: 'Avräkningar',
            POGLabel: 'Avräkningar',
            PBLabel: 'Avräkningarna',
            PBGLabel: 'Avräkningarna',
            Visible: true,
            ChildTypes: [
            ],
          },
          {
            TypeValue: 'PeriodorderMall',
            Abstract: false,
            SOLabel: 'Periodmall',
            SOGLabel: 'Periodmall',
            SBLabel: 'Periodmallen',
            SBGLabel: 'Periodmallen',
            POLabel: 'Periodmallar',
            POGLabel: 'Periodmallar',
            PBLabel: 'Periodmallarna',
            PBGLabel: 'Periodmallarna',
            Visible: true,
            ChildTypes: [
            ],
          },
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Ordern primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Ordern versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _typ: {
          AttributeName: '_typ',
          DisplayLabel: 'Ordertyp',
          DataType: 'Enum',
          EnumValues: new Map([['DIREKTORDER', 'Direktorder'], ['ERBJUDANDE', 'Erbjudande'], ['BESTORDER', 'Beställningsorder'], ['AVRAKNINGKUNDAVTAL', 'Avräkning'], ['PERIODORDERMALL', 'Periodmall']]),
          EnumSortValues: new Map([['DIREKTORDER', 'D'], ['ERBJUDANDE', 'E'], ['BESTORDER', 'R'], ['AVRAKNINGKUNDAVTAL', 'V'], ['PERIODORDERMALL', 'P']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="DIREKTORDER=Direktorder;ERBJUDANDE=Erbjudande;BESTORDER=Beställningsorder;AVRAKNINGKUNDAVTAL=Avräkning;PERIODORDERMALL=Periodmall"',
          GUIEditable: true,
          InterfaceType: 'ifTypeTree',
          Required: true,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Ordern id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Ordern fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ORDERNR: {
          AttributeName: 'ORDERNR',
          DisplayLabel: 'Ordernummer',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 10,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        ORDER_OMG: {
          AttributeName: 'ORDER_OMG',
          DisplayLabel: 'Orderomgång',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ORDERDATUM: {
          AttributeName: 'ORDERDATUM',
          DisplayLabel: 'Orderdatum',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          FormatterParseParams: 'CenturyLimit=""',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less],
          DefaultCondOperator: T.equals,
        },
        VALUTA_ID: {
          AttributeName: 'VALUTA_ID',
          DisplayLabel: 'Valuta',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        SPRAK_ID: {
          AttributeName: 'SPRAK_ID',
          DisplayLabel: 'Språk',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        STATUS: {
          AttributeName: 'STATUS',
          DisplayLabel: 'Status',
          Hint: 'Registrerad/Delfakturerad/Slutfakturerad',
          DataType: 'Enum',
          EnumValues: new Map([['REGISTRERAD', 'Registrerad'], ['DELFAKTURERAD', 'Delfakturerad'], ['SLUTFAKTURERAD', 'Slutfakturerad']]),
          EnumSortValues: new Map([['REGISTRERAD', 'R'], ['DELFAKTURERAD', 'D'], ['SLUTFAKTURERAD', 'S']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="REGISTRERAD=Registrerad;DELFAKTURERAD=Delfakturerad;SLUTFAKTURERAD=Slutfakturerad"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
        },
        LEVERANSDATUM: {
          AttributeName: 'LEVERANSDATUM',
          DisplayLabel: 'Leveransdatum',
          DataType: 'Date',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatDate',
          FormatterParseParams: 'CenturyLimit=""',
          FormatterValidateParams: 'MaxDate="+36m";MinDate="-24m";MaxRecommendedDate="+12m";MinRecommendedDate="-1m"',
          AttributeGroup: 'Övrigt',
        },
        PLANLEVDATUM: {
          AttributeName: 'PLANLEVDATUM',
          DisplayLabel: 'Planerat leveransdatum',
          DataType: 'Date',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatDate',
          FormatterParseParams: 'CenturyLimit=""',
          FormatterValidateParams: 'MaxDate="+36m";MinDate="-12m";MaxRecommendedDate="+12m";MinRecommendedDate="-0m"',
        },
        KUND_ID: {
          AttributeName: 'KUND_ID',
          DisplayLabel: 'Kundnr/Avtalsnr',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        NAMN: {
          AttributeName: 'NAMN',
          DisplayLabel: 'Namn',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatCase',
          GUIEditable: true,
          MaxInputLength: 82,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          Required: true,
        },
        CO: {
          AttributeName: 'CO',
          DisplayLabel: 'Adress, C/O',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatCase',
          GUIEditable: true,
          MaxInputLength: 40,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          AttributeGroup: 'Adress',
        },
        ADRESS: {
          AttributeName: 'ADRESS',
          DisplayLabel: 'Adress, Gatuadress',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatCase',
          GUIEditable: true,
          MaxInputLength: 40,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          AttributeGroup: 'Adress',
        },
        POSTNR: {
          AttributeName: 'POSTNR',
          DisplayLabel: 'Adress, Postnr',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatPostNr',
          GUIEditable: true,
          MaxInputLength: 10,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          AttributeGroup: 'Adress',
        },
        ORT: {
          AttributeName: 'ORT',
          DisplayLabel: 'Adress, Ort',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatCase',
          FormatterParseParams: 'LowerCase="False"',
          GUIEditable: true,
          MaxInputLength: 30,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          AttributeGroup: 'Adress',
        },
        LAND_ID: {
          AttributeName: 'LAND_ID',
          DisplayLabel: 'Land',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        LEVNAMN: {
          AttributeName: 'LEVNAMN',
          DisplayLabel: 'Leveransadress, namn',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatCase',
          GUIEditable: true,
          MaxInputLength: 40,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          AttributeGroup: 'Leveransadress',
        },
        LEVADRESS: {
          AttributeName: 'LEVADRESS',
          DisplayLabel: 'Leveransadress, Gatuadress',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatCase',
          GUIEditable: true,
          MaxInputLength: 40,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          AttributeGroup: 'Leveransadress',
        },
        LEVCO: {
          AttributeName: 'LEVCO',
          DisplayLabel: 'Leveransadress, C/O',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatCase',
          GUIEditable: true,
          MaxInputLength: 40,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          AttributeGroup: 'Leveransadress',
        },
        LEVPOSTNR: {
          AttributeName: 'LEVPOSTNR',
          DisplayLabel: 'Leveransadress, Postnr',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatPostNr',
          GUIEditable: true,
          MaxInputLength: 10,
          AttributeGroup: 'Leveransadress',
        },
        LEVORT: {
          AttributeName: 'LEVORT',
          DisplayLabel: 'Leveransadress, Ort',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatCase',
          FormatterParseParams: 'LowerCase="False"',
          GUIEditable: true,
          MaxInputLength: 40,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          AttributeGroup: 'Leveransadress',
        },
        LEVLAND_ID: {
          AttributeName: 'LEVLAND_ID',
          DisplayLabel: 'Leveransadress, Land',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BETALARE_ID: {
          AttributeName: 'BETALARE_ID',
          DisplayLabel: 'Betalare',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KUNDREFERENS: {
          AttributeName: 'KUNDREFERENS',
          DisplayLabel: 'Kundens referens',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 40,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        MOMS: {
          AttributeName: 'MOMS',
          DisplayLabel: 'Moms (J/N)',
          Hint: 'Nej/Ja',
          DataType: 'Enum',
          EnumValues: new Map([['NEJ', 'Nej'], ['JA', 'Ja']]),
          EnumSortValues: new Map([['NEJ', 'N'], ['JA', 'Y']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="NEJ=Nej;JA=Ja"',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          AttributeGroup: 'Övrigt',
        },
        PRISLISTA_ID: {
          AttributeName: 'PRISLISTA_ID',
          DisplayLabel: 'Prislista',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        RABATT: {
          AttributeName: 'RABATT',
          DisplayLabel: 'Rabatt',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatIntAsPercent',
          FormatterDisplayParams: 'Decimals="0"',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          AttributeGroup: 'Övrigt',
        },
        BETALNINGSVILLK_ID: {
          AttributeName: 'BETALNINGSVILLK_ID',
          DisplayLabel: 'Betalningsvillkor',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        LEVERANSVILLK_ID: {
          AttributeName: 'LEVERANSVILLK_ID',
          DisplayLabel: 'Leveransvillkor ID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BESTALLNINGSNR: {
          AttributeName: 'BESTALLNINGSNR',
          DisplayLabel: 'Fakturarubrik',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 255,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        RUBRIK: {
          AttributeName: 'RUBRIK',
          DisplayLabel: 'Intern rubrik',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 40,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        KLARFAKT: {
          AttributeName: 'KLARFAKT',
          DisplayLabel: 'Klar att fakturera (J/N)',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          FormatterValidateParams: 'ValidValues="N;Y"',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          AttributeGroup: 'Övrigt',
        },
        GRUPP_ID: {
          AttributeName: 'GRUPP_ID',
          DisplayLabel: 'Faktureringsgrupp ID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        SALJARE_ID: {
          AttributeName: 'SALJARE_ID',
          DisplayLabel: 'Ordermottagare ID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FAKTURERINGSSATT: {
          AttributeName: 'FAKTURERINGSSATT',
          DisplayLabel: 'Faktureringssätt',
          Hint: 'Faktura/Kontofaktura/Bankkonto/Avräkning/Autogiro/KOB',
          DataType: 'Enum',
          EnumValues: new Map([['FAKTURA', 'Faktura'], ['KONTOFAKTURA', 'Kontofaktura'], ['BANKKONTO', 'Bankkonto'], ['AVRAKNING', 'Avräkning'], ['AUTOGIRO', 'Autogiro'], ['KOB', 'KOB']]),
          EnumSortValues: new Map([['FAKTURA', 'F'], ['KONTOFAKTURA', 'K'], ['BANKKONTO', 'B'], ['AVRAKNING', 'A'], ['AUTOGIRO', 'U'], ['KOB', 'O']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="FAKTURA=Faktura;KONTOFAKTURA=Kontofaktura;BANKKONTO=Bankkonto;AVRAKNING=Avräkning;AUTOGIRO=Autogiro;KOB=KOB"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          CondOperators: [T.equals, T.notequals],
          DefaultCondOperator: T.equals,
          Required: true,
        },
        DEBFAKTURA_ID: {
          AttributeName: 'DEBFAKTURA_ID',
          DisplayLabel: 'Debetfaktura',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        VARREFERENS: {
          AttributeName: 'VARREFERENS',
          DisplayLabel: 'Vår referens',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatCase',
          FormatterParseParams: 'PersNames=" True"',
          GUIEditable: true,
          MaxInputLength: 40,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        FORFALLODATUM: {
          AttributeName: 'FORFALLODATUM',
          DisplayLabel: 'Förfallodatum',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          FormatterParseParams: 'CenturyLimit=""',
          FormatterValidateParams: 'MinDate="-0m";MaxDate="+36m";MinRecommendedDate="-0m";MaxRecommendedDate="+12m"',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        INTERN: {
          AttributeName: 'INTERN',
          DisplayLabel: 'Intern (J/N)',
          Hint: 'Nej/Ja',
          DataType: 'Enum',
          EnumValues: new Map([['NEJ', 'Nej'], ['JA', 'Ja']]),
          EnumSortValues: new Map([['NEJ', 'N'], ['JA', 'Y']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="NEJ=Nej;JA=Ja"',
        },
        ORDERERKANNANDE: {
          AttributeName: 'ORDERERKANNANDE',
          DisplayLabel: 'Ordererkännande utskrivet (J/N)',
          Hint: 'Nej/Ja',
          DataType: 'Enum',
          EnumValues: new Map([['NEJ', 'Nej'], ['JA', 'Ja']]),
          EnumSortValues: new Map([['NEJ', 'N'], ['JA', 'Y']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="NEJ=Nej;JA=Ja"',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          AttributeGroup: 'Ordererkännande',
        },
        ORDERERKANNANDE_DATUM: {
          AttributeName: 'ORDERERKANNANDE_DATUM',
          DisplayLabel: 'Ordererkännande datum',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          AttributeGroup: 'Ordererkännande',
        },
        ORDERERKANNANDE_SIGN: {
          AttributeName: 'ORDERERKANNANDE_SIGN',
          DisplayLabel: 'Ordererkännande signatur',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          AttributeGroup: 'Ordererkännande',
        },
        FAKTURATOTAL: {
          AttributeName: 'FAKTURATOTAL',
          DisplayLabel: 'Endast fakturatotal (J/N)',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
        },
        SAMFAKTURERAS: {
          AttributeName: 'SAMFAKTURERAS',
          DisplayLabel: 'Samfaktureras (J/N)',
          Hint: 'Nej/Ja',
          DataType: 'Enum',
          EnumValues: new Map([['NEJ', 'Nej'], ['JA', 'Ja']]),
          EnumSortValues: new Map([['NEJ', 'N'], ['JA', 'Y']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="NEJ=Nej;JA=Ja"',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          AttributeGroup: 'Övrigt',
        },
        KREDITORDER: {
          AttributeName: 'KREDITORDER',
          DisplayLabel: 'Kreditorder',
          Hint: 'Nej/Ja',
          DataType: 'Enum',
          EnumValues: new Map([['NEJ', 'Nej'], ['JA', 'Ja']]),
          EnumSortValues: new Map([['NEJ', 'N'], ['JA', 'Y']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="NEJ=Nej;JA=Ja"',
          GUIEditable: true,
        },
        KREDFAKTURA_BOKFGRUPP_ID: {
          AttributeName: 'KREDFAKTURA_BOKFGRUPP_ID',
          DisplayLabel: 'Kreditfakturans bokföringsgrupp ID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KREDFAKTURA_ID: {
          AttributeName: 'KREDFAKTURA_ID',
          DisplayLabel: 'Kreditfakturans ID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BETALA_FAKTURA: {
          AttributeName: 'BETALA_FAKTURA',
          DisplayLabel: 'Betala debetfaktura',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
        },
        AUTOGIRO_VAG: {
          AttributeName: 'AUTOGIRO_VAG',
          DisplayLabel: 'Autogiro, skickas till',
          Hint: 'Bankgirot/PlusGirot',
          DataType: 'Enum',
          EnumValues: new Map([['BANKGIROT', 'Bankgirot'], ['PLUSGIROT', 'PlusGirot']]),
          EnumSortValues: new Map([['BANKGIROT', 'B'], ['PLUSGIROT', 'P']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="BANKGIROT=Bankgirot;PLUSGIROT=PlusGirot"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          AttributeGroup: 'Autogiro',
        },
        AUTOGIRO_ANTAL_DELBET: {
          AttributeName: 'AUTOGIRO_ANTAL_DELBET',
          DisplayLabel: 'Autogiro, antal delbetalningar',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatInt',
          FormatterValidateParams: 'MaxValue="20"',
        },
        AUTOGIRO_PERIODICITET: {
          AttributeName: 'AUTOGIRO_PERIODICITET',
          DisplayLabel: 'Periodicitet',
          Hint: 'Varje månad/Varannan månad/Var tredje månad/Var fjärde månad/Var sjätte månad/Varje år',
          DataType: 'Enum',
          EnumValues: new Map([['VARJE_MANAD', 'Varje månad'], ['VARANNAN_MANAD', 'Varannan månad'], ['VAR_TREDJE_MANAD', 'Var tredje månad'], ['VAR_FJARDE_MANAD', 'Var fjärde månad'], ['VAR_SJATTE_MANAD', 'Var sjätte månad'], ['VARJE_AR', 'Varje år']]),
          EnumSortValues: new Map([['VARJE_MANAD', '1'], ['VARANNAN_MANAD', '2'], ['VAR_TREDJE_MANAD', '3'], ['VAR_FJARDE_MANAD', '4'], ['VAR_SJATTE_MANAD', '6'], ['VARJE_AR', '12']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="VARJE_MANAD=Varje månad;VARANNAN_MANAD=Varannan månad;VAR_TREDJE_MANAD=Var tredje månad;VAR_FJARDE_MANAD=Var fjärde månad;VAR_SJATTE_MANAD=Var sjätte månad;VARJE_AR=Varje år"',
        },
        AUTOGIRO_BETALNINGSDAG: {
          AttributeName: 'AUTOGIRO_BETALNINGSDAG',
          DisplayLabel: 'Autogiro, betalningsdag',
          Hint: 'Sista bankdag/1/2/3/4/5/6/7/8/9/10/11/12/13/14/15/16/17/18/19/20/21/22/23/24/25/26/27/28/29/30/31',
          DataType: 'Enum',
          EnumValues: new Map([['ASISTA_BANKDAG', 'Sista bankdag'], ['A1', '1'], ['A2', '2'], ['A3', '3'], ['A4', '4'], ['A5', '5'], ['A6', '6'], ['A7', '7'], ['A8', '8'], ['A9', '9'], ['A10', '10'], ['A11', '11'], ['A12', '12'], ['A13', '13'], ['A14', '14'], ['A15', '15'], ['A16', '16'], ['A17', '17'], ['A18', '18'], ['A19', '19'], ['A20', '20'], ['A21', '21'], ['A22', '22'], ['A23', '23'], ['A24', '24'], ['A25', '25'], ['A26', '26'], ['A27', '27'], ['A28', '28'], ['A29', '29'], ['A30', '30'], ['A31', '31']]),
          EnumSortValues: new Map([['ASISTA_BANKDAG', '0'], ['A1', '1'], ['A2', '2'], ['A3', '3'], ['A4', '4'], ['A5', '5'], ['A6', '6'], ['A7', '7'], ['A8', '8'], ['A9', '9'], ['A10', '10'], ['A11', '11'], ['A12', '12'], ['A13', '13'], ['A14', '14'], ['A15', '15'], ['A16', '16'], ['A17', '17'], ['A18', '18'], ['A19', '19'], ['A20', '20'], ['A21', '21'], ['A22', '22'], ['A23', '23'], ['A24', '24'], ['A25', '25'], ['A26', '26'], ['A27', '27'], ['A28', '28'], ['A29', '29'], ['A30', '30'], ['A31', '31']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="ASISTA_BANKDAG=Sista bankdag;A1=1;A2=2;A3=3;A4=4;A5=5;A6=6;A7=7;A8=8;A9=9;A10=10;A11=11;A12=12;A13=13;A14=14;A15=15;A16=16;A17=17;A18=18;A19=19;A20=20;A21=21;A22=22;A23=23;A24=24;A25=25;A26=26;A27=27;A28=28;A29=29;A30=30;A31=31"',
        },
        AUTOGIRO_SLUTBETALAS: {
          AttributeName: 'AUTOGIRO_SLUTBETALAS',
          DisplayLabel: 'Autogiro, slutbetald innev. år',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
        },
        AUTOGIRO_CLEARINGNR: {
          AttributeName: 'AUTOGIRO_CLEARINGNR',
          DisplayLabel: 'Autogiro, clearingnr',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 4,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          AttributeGroup: 'Autogiro',
        },
        AUTOGIRO_KONTONR: {
          AttributeName: 'AUTOGIRO_KONTONR',
          DisplayLabel: 'Autogiro, kontonr',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 15,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          AttributeGroup: 'Autogiro',
        },
        AUTOGIRO_BETMANAD_1: {
          AttributeName: 'AUTOGIRO_BETMANAD_1',
          DisplayLabel: 'Autogiro, dragning januari',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
        },
        AUTOGIRO_BETMANAD_2: {
          AttributeName: 'AUTOGIRO_BETMANAD_2',
          DisplayLabel: 'Autogiro, dragning februari',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
        },
        AUTOGIRO_BETMANAD_3: {
          AttributeName: 'AUTOGIRO_BETMANAD_3',
          DisplayLabel: 'Autogiro, dragning mars',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
        },
        AUTOGIRO_BETMANAD_4: {
          AttributeName: 'AUTOGIRO_BETMANAD_4',
          DisplayLabel: 'Autogiro, dragning april',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
        },
        AUTOGIRO_BETMANAD_5: {
          AttributeName: 'AUTOGIRO_BETMANAD_5',
          DisplayLabel: 'Autogiro, dragning maj',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
        },
        AUTOGIRO_BETMANAD_6: {
          AttributeName: 'AUTOGIRO_BETMANAD_6',
          DisplayLabel: 'Autogiro, dragning juni',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
        },
        AUTOGIRO_BETMANAD_7: {
          AttributeName: 'AUTOGIRO_BETMANAD_7',
          DisplayLabel: 'Autogiro, dragning juli',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
        },
        AUTOGIRO_BETMANAD_8: {
          AttributeName: 'AUTOGIRO_BETMANAD_8',
          DisplayLabel: 'Autogiro, dragning augusti',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
        },
        AUTOGIRO_BETMANAD_9: {
          AttributeName: 'AUTOGIRO_BETMANAD_9',
          DisplayLabel: 'Autogiro, dragning september',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
        },
        AUTOGIRO_BETMANAD_10: {
          AttributeName: 'AUTOGIRO_BETMANAD_10',
          DisplayLabel: 'Autogiro, dragning oktober',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
        },
        AUTOGIRO_BETMANAD_11: {
          AttributeName: 'AUTOGIRO_BETMANAD_11',
          DisplayLabel: 'Autogiro, dragning november',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
        },
        AUTOGIRO_BETMANAD_12: {
          AttributeName: 'AUTOGIRO_BETMANAD_12',
          DisplayLabel: 'Autogiro, dragning december',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
        },
        AUTOGIRO_BETALARNR: {
          AttributeName: 'AUTOGIRO_BETALARNR',
          DisplayLabel: 'Autogiro, betalarnr',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ORDERKATEGORI_ID: {
          AttributeName: 'ORDERKATEGORI_ID',
          DisplayLabel: 'Orderkategori, id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FAKTURA_NR: {
          AttributeName: 'FAKTURA_NR',
          DisplayLabel: 'Manuellt registrerat fakturanr',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        TotBelopp: {
          AttributeName: 'TotBelopp',
          DisplayLabel: 'Orderbelopp exkl moms',
          Hint: 'Total för alla orderrader, inkl all delfakturering, exkl moms',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatCurr',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less],
          DefaultCondOperator: T.interval,
          AttributeGroup: 'Belopp',
        },
        TotBelopp2: {
          AttributeName: 'TotBelopp2',
          DisplayLabel: 'Totalbelopp2',
          DataType: 'Currency',
          Attribute: 'Internal',
          Condition: 'None',
        },
        TotFakturaBelopp: {
          AttributeName: 'TotFakturaBelopp',
          DisplayLabel: 'Fakturabelopp exkl moms',
          Hint: 'Klarmarkerade rader att fakturera exkl moms',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatCurr',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          AttributeGroup: 'Belopp',
        },
        TotFakturaMoms: {
          AttributeName: 'TotFakturaMoms',
          DisplayLabel: 'Total fakturamoms',
          Hint: 'Den totala fakturamomsen för ordern',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatCurr',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          AttributeGroup: 'Belopp',
        },
        TotOrderMoms: {
          AttributeName: 'TotOrderMoms',
          DisplayLabel: 'Total ordermoms',
          DataType: 'Currency',
          Attribute: 'Internal',
          Condition: 'None',
        },
        TotFakturaMoms2: {
          AttributeName: 'TotFakturaMoms2',
          DisplayLabel: 'Total fakturamoms',
          DataType: 'Currency',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BetalningsvillkorText: {
          AttributeName: 'BetalningsvillkorText',
          DisplayLabel: 'Betalningsvillkor',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BetalningsvillkorText2: {
          AttributeName: 'BetalningsvillkorText2',
          DisplayLabel: 'Betalningsvillkor2',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        LeveransvillkorBen: {
          AttributeName: 'LeveransvillkorBen',
          DisplayLabel: 'Leveransvillkor',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        SarskildFakturaAdress: {
          AttributeName: 'SarskildFakturaAdress',
          DisplayLabel: 'Faktureringsadress, etikett',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          AttributeGroup: 'Fakturaadress',
        },
        BetalningsvillkorKRAVRUTIN_ID: {
          AttributeName: 'BetalningsvillkorKRAVRUTIN_ID',
          DisplayLabel: 'BetalningsvillkorKRAVRUTIN_ID',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BetalningsvillkorANTALDAGAR: {
          AttributeName: 'BetalningsvillkorANTALDAGAR',
          DisplayLabel: 'BetalningsvillkorANTALDAGAR',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KundTYP: {
          AttributeName: 'KundTYP',
          DisplayLabel: 'KundTYP',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KundKontoNr: {
          AttributeName: 'KundKontoNr',
          DisplayLabel: 'Kundnr/Avtalsnr',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KundNamn: {
          AttributeName: 'KundNamn',
          DisplayLabel: 'KundNamn',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KundCO: {
          AttributeName: 'KundCO',
          DisplayLabel: 'Kundens CO',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BankkontoNr: {
          AttributeName: 'BankkontoNr',
          DisplayLabel: 'Bankkontonummer',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KundBANKNAMN: {
          AttributeName: 'KundBANKNAMN',
          DisplayLabel: 'Kundens banknamn',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Clearingnr: {
          AttributeName: 'Clearingnr',
          DisplayLabel: 'Clearingnr',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KundLAND_ID: {
          AttributeName: 'KundLAND_ID',
          DisplayLabel: 'Kundens landID',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KundDROJSMALSRANTEFAKT: {
          AttributeName: 'KundDROJSMALSRANTEFAKT',
          DisplayLabel: 'KundDROJSMALSRANTEFAKT',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KundKUNDKATEGORI_ID: {
          AttributeName: 'KundKUNDKATEGORI_ID',
          DisplayLabel: 'KundKUNDKATEGORI_ID',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KundFAKTURERINGSAVGIFT: {
          AttributeName: 'KundFAKTURERINGSAVGIFT',
          DisplayLabel: 'KundFAKTURERINGSAVGIFT',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KundADMAVGKONTOFAKTURA: {
          AttributeName: 'KundADMAVGKONTOFAKTURA',
          DisplayLabel: 'KundADMAVGKONTOFAKTURA',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KundKontoSaldoaktuellt: {
          AttributeName: 'KundKontoSaldoaktuellt',
          DisplayLabel: 'Aktuellt saldo för kundkonto',
          DataType: 'Currency',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KundKREDITERA_TILLGODOH: {
          AttributeName: 'KundKREDITERA_TILLGODOH',
          DisplayLabel: 'Kund kreditera tillgodohavande',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BetKUNDNR_KONTONR: {
          AttributeName: 'BetKUNDNR_KONTONR',
          DisplayLabel: 'Betalarens kund/kontonummer',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KundBetalareNamn: {
          AttributeName: 'KundBetalareNamn',
          DisplayLabel: 'Betalarens namn',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KundBetalareCO: {
          AttributeName: 'KundBetalareCO',
          DisplayLabel: 'Betalarens CO',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KundBetalareGatuadress: {
          AttributeName: 'KundBetalareGatuadress',
          DisplayLabel: 'Betalarens gatuadress',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KundBetalarePostNr: {
          AttributeName: 'KundBetalarePostNr',
          DisplayLabel: 'Betalarens postnummer',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatPostNr',
        },
        KundBetalareOrt: {
          AttributeName: 'KundBetalareOrt',
          DisplayLabel: 'Betalarens ort',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KundBetalareTYP: {
          AttributeName: 'KundBetalareTYP',
          DisplayLabel: 'Betalarens kundtyp',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BetBANKKONTONUMMER: {
          AttributeName: 'BetBANKKONTONUMMER',
          DisplayLabel: 'Betalarens bankkontonummer',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BetKontoSaldoaktuellt: {
          AttributeName: 'BetKontoSaldoaktuellt',
          DisplayLabel: 'KundBetalareKontoSaldoaktuellt',
          DataType: 'Currency',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BetKUNDKATEGORI_ID: {
          AttributeName: 'BetKUNDKATEGORI_ID',
          DisplayLabel: 'KundBetalareKUNDKATEGORI_ID',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BetKREDITERA_TILLGODOH: {
          AttributeName: 'BetKREDITERA_TILLGODOH',
          DisplayLabel: 'KundBetalareKREDITERA_TILLGODOH',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BetClearingNr: {
          AttributeName: 'BetClearingNr',
          DisplayLabel: 'Betalarens clearingnr',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KundBetalareLAND_ID: {
          AttributeName: 'KundBetalareLAND_ID',
          DisplayLabel: 'KundBetalareLAND_ID',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BetFAKTURERINGSAVGIFT: {
          AttributeName: 'BetFAKTURERINGSAVGIFT',
          DisplayLabel: 'KundBetalareFAKTURERINGSAVGIFT',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BetADMAVGKONTOFAKTURA: {
          AttributeName: 'BetADMAVGKONTOFAKTURA',
          DisplayLabel: 'BetADMAVGKONTOFAKTURA',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Land: {
          AttributeName: 'Land',
          DisplayLabel: 'Adress, land',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          AttributeGroup: 'Adress',
        },
        GruppOrdertyp: {
          AttributeName: 'GruppOrdertyp',
          DisplayLabel: 'Faktureringsgruppens ordertyp',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KravrutinID: {
          AttributeName: 'KravrutinID',
          DisplayLabel: 'KravrutinID',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        SprakID: {
          AttributeName: 'SprakID',
          DisplayLabel: 'SprakID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Prislista: {
          AttributeName: 'Prislista',
          DisplayLabel: 'Prislista',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Övrigt',
        },
        LeverantorsAdress: {
          AttributeName: 'LeverantorsAdress',
          DisplayLabel: 'Leveransadress, etikett',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          AttributeGroup: 'Leveransadress',
        },
        LevLand: {
          AttributeName: 'LevLand',
          DisplayLabel: 'Leveransadress, land',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          AttributeGroup: 'Leveransadress',
        },
        KredFaktNr: {
          AttributeName: 'KredFaktNr',
          DisplayLabel: 'Kreditorder- debetfakturans fakturanr',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KredFaktDatum: {
          AttributeName: 'KredFaktDatum',
          DisplayLabel: 'Kreditorder - debetfakturans fakturadatum',
          DataType: 'DateTime',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatDate',
        },
        KredFaktForfallodatum: {
          AttributeName: 'KredFaktForfallodatum',
          DisplayLabel: 'Kreditorder - debetfakturans förfallodatum',
          DataType: 'DateTime',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatDate',
        },
        KredFaktSlutbetald: {
          AttributeName: 'KredFaktSlutbetald',
          DisplayLabel: 'Kreditorder - debetfakturan slutbetald',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterParseParams: 'TranslateValues=""',
          FormatterDisplayParams: 'TranslateValues=""',
          FormatterValidateParams: 'ValidValues=""',
        },
        InternKund: {
          AttributeName: 'InternKund',
          DisplayLabel: 'Intern kund',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        InternKundBetalare: {
          AttributeName: 'InternKundBetalare',
          DisplayLabel: 'Intern betalare',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ORDERUNDERLAG_ID: {
          AttributeName: 'ORDERUNDERLAG_ID',
          DisplayLabel: 'Orderunderlag, id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Faktgrupp: {
          AttributeName: 'Faktgrupp',
          DisplayLabel: 'Faktureringsgrupp',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        RANTEOMGANG_ID: {
          AttributeName: 'RANTEOMGANG_ID',
          DisplayLabel: 'Ränteomgång, id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatInt',
          ValidInComps: ['Direktorder'],
        },
        KOB_PERS_NR: {
          AttributeName: 'KOB_PERS_NR',
          DisplayLabel: 'Clearing, personnummer',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatPersNr',
          GUIEditable: true,
          MaxInputLength: 13,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          ValidInComps: ['Direktorder'],
          AttributeGroup: 'Clearing',
        },
        KOB_DATUM: {
          AttributeName: 'KOB_DATUM',
          DisplayLabel: 'Clearing, handlingsdatum',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          ValidInComps: ['Direktorder'],
          AttributeGroup: 'Clearing',
        },
        FORRATTNINGSTYP: {
          AttributeName: 'FORRATTNINGSTYP',
          DisplayLabel: 'Clearing, förrättningstyp',
          Hint: 'Begravning/Vigsel/Konfirmation/Dop/Statlig clearing/Övrigt',
          DataType: 'Enum',
          EnumValues: new Map([['BEGRAVNING', 'Begravning'], ['VIGSEL', 'Vigsel'], ['KONFIRMATION', 'Konfirmation'], ['DOP', 'Dop'], ['STATLIG_CLEARING', 'Statlig clearing'], ['OVRIGT', 'Övrigt']]),
          EnumSortValues: new Map([['BEGRAVNING', '1'], ['VIGSEL', '2'], ['KONFIRMATION', '3'], ['DOP', '4'], ['STATLIG_CLEARING', '5'], ['OVRIGT', '6']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="BEGRAVNING=Begravning;VIGSEL=Vigsel;KONFIRMATION=Konfirmation;DOP=Dop;STATLIG_CLEARING=Statlig clearing;OVRIGT=Övrigt"',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          ValidInComps: ['Direktorder'],
          AttributeGroup: 'Clearing',
        },
        KOB_DODSDATUM: {
          AttributeName: 'KOB_DODSDATUM',
          DisplayLabel: 'Clearing, dödsdatum',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDateStr',
          FormatterParseParams: 'AllowIncomplete="Y"',
          GUIEditable: true,
          MaxInputLength: 10,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          ValidInComps: ['Direktorder'],
          AttributeGroup: 'Clearing',
        },
        KOB_HEMFORSAMLING: {
          AttributeName: 'KOB_HEMFORSAMLING',
          DisplayLabel: 'Clearing, hemförsamling',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatOrgNr',
          GUIEditable: true,
          MaxInputLength: 60,
          ValidInComps: ['Direktorder'],
          AttributeGroup: 'Clearing',
        },
        KOB_PERSNAMN: {
          AttributeName: 'KOB_PERSNAMN',
          DisplayLabel: 'Clearing, personnamn',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 200,
          ValidInComps: ['Direktorder'],
          AttributeGroup: 'Clearing',
        },
        KOB_PERS_NR2: {
          AttributeName: 'KOB_PERS_NR2',
          DisplayLabel: 'Clearing, personnummer 2',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatPersNr',
          GUIEditable: true,
          MaxInputLength: 13,
          ValidInComps: ['Direktorder'],
          AttributeGroup: 'Clearing',
        },
        KOB_PERSNAMN2: {
          AttributeName: 'KOB_PERSNAMN2',
          DisplayLabel: 'Clearing, personnamn2',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 200,
          ValidInComps: ['Direktorder'],
          AttributeGroup: 'Clearing',
        },
        clearing: {
          AttributeName: 'clearing',
          DisplayLabel: 'Clearing',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          ValidInComps: ['Direktorder'],
        },
        ARBETSORDER: {
          AttributeName: 'ARBETSORDER',
          DisplayLabel: 'Arbetsorder',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          ValidInComps: ['BestOrder'],
          AttributeGroup: 'Arbetsorder',
        },
        ARBETSORDER_DATUM: {
          AttributeName: 'ARBETSORDER_DATUM',
          DisplayLabel: 'Arbetsorder, datum',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          ValidInComps: ['BestOrder'],
          AttributeGroup: 'Arbetsorder',
        },
        ARBETSORDER_SIGN: {
          AttributeName: 'ARBETSORDER_SIGN',
          DisplayLabel: 'Arbetsorder, signatur',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          ValidInComps: ['BestOrder'],
          AttributeGroup: 'Arbetsorder',
        },
        AterstarAttFakturera: {
          AttributeName: 'AterstarAttFakturera',
          DisplayLabel: 'Återstår att fakturera',
          DataType: 'Currency',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          ValidInComps: ['BestOrder'],
          AttributeGroup: 'Belopp',
        },
        TidigareFakturererat: {
          AttributeName: 'TidigareFakturererat',
          DisplayLabel: 'Fakturererat belopp',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          ValidInComps: ['BestOrder'],
          AttributeGroup: 'Belopp',
        },
        AVTAL_AVRAKNAT_TOM: {
          AttributeName: 'AVTAL_AVRAKNAT_TOM',
          DisplayLabel: 'Avräknat t.o.m',
          DataType: 'Date',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatDateMonth',
          ValidInComps: ['AvrakningKundavtal'],
        },
        AvrJustBelopp: {
          AttributeName: 'AvrJustBelopp',
          DisplayLabel: 'Justeringsbelopp',
          DataType: 'Currency',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['AvrakningKundavtal'],
        },
        PERIOD_SLUTDATUM: {
          AttributeName: 'PERIOD_SLUTDATUM',
          DisplayLabel: 'Periodmall, slutmånad',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDateMonth',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          ValidInComps: ['PeriodorderMall'],
          AttributeGroup: 'Övrigt',
        },
        PERIOD_ANTALMAN: {
          AttributeName: 'PERIOD_ANTALMAN',
          DisplayLabel: 'Periodmall, antal månader',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatInt',
          FormatterValidateParams: 'MinValue="1";MaxValue="12"',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          ValidInComps: ['PeriodorderMall'],
          AttributeGroup: 'Övrigt',
        },
        PERIOD_NASTADATUM: {
          AttributeName: 'PERIOD_NASTADATUM',
          DisplayLabel: 'Periodmall, nästa månad',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDateMonth',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          ValidInComps: ['PeriodorderMall'],
          AttributeGroup: 'Övrigt',
        },
        KOB_ORGANISATIONSAR: {
          AttributeName: 'KOB_ORGANISATIONSAR',
          DisplayLabel: 'Clearing, organisationsår',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatInt',
          FormatterValidateParams: 'MinValue="1900";MaxValue="2100"',
          ValidInComps: ['Direktorder'],
          AttributeGroup: 'Clearing',
        },
        KOB_GRAVPLATSBETECKNING: {
          AttributeName: 'KOB_GRAVPLATSBETECKNING',
          DisplayLabel: 'Clearing, gravplatsbeteckning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Clearing',
        },
        Sam: {
          AttributeName: 'Sam',
          DisplayLabel: 'Beräknar samfaktureringsbegrepp',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        SortPostnr: {
          AttributeName: 'SortPostnr',
          DisplayLabel: 'SortPostnr',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KOB_GRAVSATTNINGSDATUM: {
          AttributeName: 'KOB_GRAVSATTNINGSDATUM',
          DisplayLabel: 'Clearing, gravsättningsdatum',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          ValidInComps: ['Direktorder'],
          AttributeGroup: 'Clearing',
        },
        FAKTNAMN: {
          AttributeName: 'FAKTNAMN',
          DisplayLabel: 'Avvikande fakt.adress, namn',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 60,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Avvikande fakt.adress',
        },
        FAKTADRESS: {
          AttributeName: 'FAKTADRESS',
          DisplayLabel: 'Avvikande fakt.adress, gatuadress',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 40,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Avvikande fakt.adress',
        },
        FAKTCO: {
          AttributeName: 'FAKTCO',
          DisplayLabel: 'Avvikande fakt.adress, co',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 40,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Avvikande fakt.adress',
        },
        FAKTPOSTNR: {
          AttributeName: 'FAKTPOSTNR',
          DisplayLabel: 'Avvikande fakt.adress, postnr',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatPostNr',
          GUIEditable: true,
          MaxInputLength: 10,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Avvikande fakt.adress',
        },
        FAKTORT: {
          AttributeName: 'FAKTORT',
          DisplayLabel: 'Avvikande fakt.adresss, ort',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 40,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Avvikande fakt.adress',
        },
        FAKTLAND_ID: {
          AttributeName: 'FAKTLAND_ID',
          DisplayLabel: 'Faktureringsadress, land',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FaktureringsLand: {
          AttributeName: 'FaktureringsLand',
          DisplayLabel: 'Avvikande fakt.adress, land',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          AttributeGroup: 'Avvikande fakt.adress',
        },
        IFaktNamn: {
          AttributeName: 'IFaktNamn',
          DisplayLabel: 'Faktureringsadress, namn',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          AttributeGroup: 'Faktureringsadress',
        },
        IFaktCO: {
          AttributeName: 'IFaktCO',
          DisplayLabel: 'Faktureringsadress, C/O',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          AttributeGroup: 'Faktureringsadress',
        },
        IFaktAdress: {
          AttributeName: 'IFaktAdress',
          DisplayLabel: 'Faktureringsadress, gatuadress',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          AttributeGroup: 'Faktureringsadress',
        },
        IFaktPostnr: {
          AttributeName: 'IFaktPostnr',
          DisplayLabel: 'Faktureringsadress, postnr',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatPostNr',
          AttributeGroup: 'Faktureringsadress',
        },
        IFaktOrt: {
          AttributeName: 'IFaktOrt',
          DisplayLabel: 'Faktureringsadress, ort',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          AttributeGroup: 'Faktureringsadress',
        },
        IFaktLandKod: {
          AttributeName: 'IFaktLandKod',
          DisplayLabel: 'IFaktLandKod',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        IFaktLand: {
          AttributeName: 'IFaktLand',
          DisplayLabel: 'Faktureringsadress, land',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          AttributeGroup: 'Faktureringsadress',
        },
        IFaktLandId: {
          AttributeName: 'IFaktLandId',
          DisplayLabel: 'IFaktLandId',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FakturaAdress: {
          AttributeName: 'FakturaAdress',
          DisplayLabel: 'Adress, etikett',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        HarSarskildFaktureringsadress: {
          AttributeName: 'HarSarskildFaktureringsadress',
          DisplayLabel: 'HarSarskildFaktureringsadress',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'None',
        },
        IMPORT_IDENTIFIKATION: {
          AttributeName: 'IMPORT_IDENTIFIKATION',
          DisplayLabel: 'Import Id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          AttributeGroup: 'Sveorder',
        },
        IMPORT_XML: {
          AttributeName: 'IMPORT_XML',
          DisplayLabel: 'Import XML',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          AttributeGroup: 'Sveorder',
        },
        IMPORT_ORGNR: {
          AttributeName: 'IMPORT_ORGNR',
          DisplayLabel: 'Import, Orgnr.',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          AttributeGroup: 'Sveorder',
        },
        KREDITERAR_ORDERNR: {
          AttributeName: 'KREDITERAR_ORDERNR',
          DisplayLabel: 'Krediterar ordernummer',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 10,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Sveorder',
        },
        AVRUNDNINGS_BELOPP: {
          AttributeName: 'AVRUNDNINGS_BELOPP',
          DisplayLabel: 'Öresavrundningsbelopp',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          AttributeGroup: 'Sveorder',
        },
        SveOrder: {
          AttributeName: 'SveOrder',
          DisplayLabel: 'SveOrder',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KREDIT_BETALINSTR: {
          AttributeName: 'KREDIT_BETALINSTR',
          DisplayLabel: 'Kredit. betalinstruktion',
          Hint: 'Betala debetfaktura/Tillgodohavande/Utbetalas/Kreditfaktura/Rest utbetalas',
          DataType: 'Enum',
          EnumValues: new Map([['BETALA_DEBETFAKTURA', 'Betala debetfaktura'], ['TILLGODOHAVANDE', 'Tillgodohavande'], ['UTBETALAS', 'Utbetalas'], ['KREDITFAKTURA', 'Kreditfaktura'], ['REST_UTBETALAS', 'Rest utbetalas']]),
          EnumSortValues: new Map([['BETALA_DEBETFAKTURA', 'B'], ['TILLGODOHAVANDE', 'T'], ['UTBETALAS', 'U'], ['KREDITFAKTURA', 'K'], ['REST_UTBETALAS', 'R']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="BETALA_DEBETFAKTURA=Betala debetfaktura;TILLGODOHAVANDE=Tillgodohavande;UTBETALAS=Utbetalas;KREDITFAKTURA=Kreditfaktura;REST_UTBETALAS=Rest utbetalas"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Sveorder',
        },
        KREDIT_SKICKA: {
          AttributeName: 'KREDIT_SKICKA',
          DisplayLabel: 'Kredit, skicka faktura',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Sveorder',
        },
        KOB_FOLKBOKFFORSAML: {
          AttributeName: 'KOB_FOLKBOKFFORSAML',
          DisplayLabel: 'Clearing, folkbokf församling',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 60,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Clearing',
        },
        IMPORT_KUNDNR: {
          AttributeName: 'IMPORT_KUNDNR',
          DisplayLabel: 'Import, kundnr',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 20,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Sveorder',
        },
        GravSkotselID: {
          AttributeName: 'GravSkotselID',
          DisplayLabel: 'GravSkotselID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        GravskotselAr: {
          AttributeName: 'GravskotselAr',
          DisplayLabel: 'Gravskötselår',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatIntAsYear',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          AttributeGroup: 'Gravskötsel',
        },
        FAKTURATEXT: {
          AttributeName: 'FAKTURATEXT',
          DisplayLabel: 'Fakturatext',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 255,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        StatusKlarfakt: {
          AttributeName: 'StatusKlarfakt',
          DisplayLabel: 'Status',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        REG_AV_ID: {
          AttributeName: 'REG_AV_ID',
          DisplayLabel: 'Registrerat av, Id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        HarKrediteradFaktura: {
          AttributeName: 'HarKrediteradFaktura',
          DisplayLabel: 'Har krediterad faktura',
          Hint: 'Internt fält - Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
        },
        FakturaSenasteBetalnDatum: {
          AttributeName: 'FakturaSenasteBetalnDatum',
          DisplayLabel: 'Fakturans senaste betalningsdatum',
          Hint: 'Internt fält',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatDate',
        },
        HarMakuleradFaktura: {
          AttributeName: 'HarMakuleradFaktura',
          DisplayLabel: 'Har makulerad faktura',
          Hint: 'Internt fält - Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
        },
        IFakturabunt: {
          AttributeName: 'IFakturabunt',
          DisplayLabel: 'Finns i fakturabunt',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
        },
        GDPRReferensdatumKund: {
          AttributeName: 'GDPRReferensdatumKund',
          DisplayLabel: 'GDPR referensdatum för kunduppgifter',
          DataType: 'DateTime',
          Attribute: 'Internal',
          Condition: 'Internal',
          Formatter: 'TEDFormatDate',
          InterfaceType: 'ifNone',
        },
        HarOppenFakturaJournaler: {
          AttributeName: 'HarOppenFakturaJournaler',
          DisplayLabel: 'Fakturans journal är öppen',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'Internal',
          Formatter: 'TEDFormatBool',
          InterfaceType: 'ifNone',
        },
        GALLRAD_KUNDUPPG: {
          AttributeName: 'GALLRAD_KUNDUPPG',
          DisplayLabel: 'Gallrad på kunduppgifter',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        GALLRAD_CLEARINGUPPG: {
          AttributeName: 'GALLRAD_CLEARINGUPPG',
          DisplayLabel: 'Gallrad på clearinguppgifter',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        GALLRAD_KUNDUPPG_DATUM: {
          AttributeName: 'GALLRAD_KUNDUPPG_DATUM',
          DisplayLabel: 'Gallrad kunduppg, datum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        GALLRAD_CLEARINGUPPG_DATUM: {
          AttributeName: 'GALLRAD_CLEARINGUPPG_DATUM',
          DisplayLabel: 'Gallrad clearinguppg, datum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        IFaktnr: {
          AttributeName: 'IFaktnr',
          DisplayLabel: 'Fakturanr',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        IFaktStatus: {
          AttributeName: 'IFaktStatus',
          DisplayLabel: 'Fakturastatus',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        TILLGANGLIG_DATUM: {
          AttributeName: 'TILLGANGLIG_DATUM',
          DisplayLabel: 'Tillgänglig, datum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDateTime',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        MANUELL_ORDER: {
          AttributeName: 'MANUELL_ORDER',
          DisplayLabel: 'Manuell order',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        FakturaBeloppInklMoms: {
          AttributeName: 'FakturaBeloppInklMoms',
          DisplayLabel: 'Belopp inkl moms',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'None',
        },
        OrderBeloppInklMoms: {
          AttributeName: 'OrderBeloppInklMoms',
          DisplayLabel: 'Belopp inkl moms',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BEVAKA_FAKTURABETALNING: {
          AttributeName: 'BEVAKA_FAKTURABETALNING',
          DisplayLabel: 'Bevaka fakturabetalning',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        AVSER_PERIOD_FRAN: {
          AttributeName: 'AVSER_PERIOD_FRAN',
          DisplayLabel: 'Avser period, fr o m',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDateMonth',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          AttributeGroup: 'Övrigt',
        },
        AVSER_PERIOD_TILL: {
          AttributeName: 'AVSER_PERIOD_TILL',
          DisplayLabel: 'Avser period, t o m',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDateMonth',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          AttributeGroup: 'Övrigt',
        },
        FRAN_PERIODORDER_ID: {
          AttributeName: 'FRAN_PERIODORDER_ID',
          DisplayLabel: 'Skapad från periodorder, id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Periodintervall: {
          AttributeName: 'Periodintervall',
          DisplayLabel: 'Periodintervall',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          AttributeGroup: 'Övrigt',
        },
        OrdernrMall: {
          AttributeName: 'OrdernrMall',
          DisplayLabel: 'Mallens ordernr',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifNone',
          AttributeGroup: 'Övrigt',
        },
        Periodorder: {
          AttributeName: 'Periodorder',
          DisplayLabel: 'Periodorder',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          InterfaceType: 'ifBoolean',
          AttributeGroup: 'Övrigt',
        },
        PERIODMALL_AVSLUTAD: {
          AttributeName: 'PERIODMALL_AVSLUTAD',
          DisplayLabel: 'Periodmall, avslutad',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Övrigt',
        },
        PERIODMALL_AVSLUTAD_DATUM: {
          AttributeName: 'PERIODMALL_AVSLUTAD_DATUM',
          DisplayLabel: 'Periodmall, avslutad datum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          AttributeGroup: 'Övrigt',
        },
        KONV_PERIODORDER_ID: {
          AttributeName: 'KONV_PERIODORDER_ID',
          DisplayLabel: 'Konverterad från periodmall, id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        HarBilagor: {
          AttributeName: 'HarBilagor',
          DisplayLabel: 'Har bilagor',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          InterfaceType: 'ifNone',
        },
        PERIODISERAD: {
          AttributeName: 'PERIODISERAD',
          DisplayLabel: 'Periodiserad',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        PERIODISERAD_PERIOD_FRAN: {
          AttributeName: 'PERIODISERAD_PERIOD_FRAN',
          DisplayLabel: 'Periodiserad, period fr o m',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDateMonth',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        PERIODISERAD_PERIOD_TILL: {
          AttributeName: 'PERIODISERAD_PERIOD_TILL',
          DisplayLabel: 'Periodiserad, period t o m',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDateMonth',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        PERIODMALL_UPPDATERA_PRISER: {
          AttributeName: 'PERIODMALL_UPPDATERA_PRISER',
          DisplayLabel: 'Periodmall, använd aktuella priser',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Övrigt',
        },
        BACKINFO_PERIOD_NASTADATUM: {
          AttributeName: 'BACKINFO_PERIOD_NASTADATUM',
          DisplayLabel: 'Backningsinfo, period nästa datum',
          DataType: 'Date',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
      },
      Associations: {
        Valuta: {
          AssociationName: 'Valuta',
          DisplayLabel: 'Valuta',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'SYSValuta',
          AssociatedComponentName: 'Valuta',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Sprak: {
          AssociationName: 'Sprak',
          DisplayLabel: 'Språk',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'SYSSprak',
          AssociatedComponentName: 'Sprak',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Kund: {
          AssociationName: 'Kund',
          DisplayLabel: 'Kund',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'KRKund',
          AssociatedComponentName: 'Kund',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([['KUND_NOCOMBINE', 'True'], ['NOT_ATAGANDE', 'True']]),
          Required: true,
        },
        Prislista: {
          AssociationName: 'Prislista',
          DisplayLabel: 'Prislista',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'LAPrislista',
          AssociatedComponentName: 'Prislista',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Betalningsvillkor: {
          AssociationName: 'Betalningsvillkor',
          DisplayLabel: 'Betalningsvillkor',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'SYSBetalningsvillkor',
          AssociatedComponentName: 'Betalningsvillkor',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Leveransvillkor: {
          AssociationName: 'Leveransvillkor',
          DisplayLabel: 'Leveransvillkor',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'SYSLeveransvillkor',
          AssociatedComponentName: 'Leveransvillkor',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Saljare: {
          AssociationName: 'Saljare',
          DisplayLabel: 'Ordermottagare',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'OFSaljare',
          AssociatedComponentName: 'Saljare',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        KundBetalare: {
          AssociationName: 'KundBetalare',
          DisplayLabel: 'Betalare',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'KRKund',
          AssociatedComponentName: 'Kund',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([['KUND_NOCOMBINE', 'True'], ['NOT_ATAGANDE', 'True']]),
        },
        Grupp: {
          AssociationName: 'Grupp',
          DisplayLabel: 'Bokföringsgrupp',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'SYSGrupp',
          AssociatedComponentName: 'BokfgruppFakt',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
          Required: true,
        },
        Debetfaktura: {
          AssociationName: 'Debetfaktura',
          DisplayLabel: 'Debetfaktura',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'KRFaktura',
          AssociatedComponentName: 'Faktura',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Kreditfaktura: {
          AssociationName: 'Kreditfaktura',
          DisplayLabel: 'Kreditfaktura',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'KRFaktura',
          AssociatedComponentName: 'Faktura',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Land: {
          AssociationName: 'Land',
          DisplayLabel: 'Land',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'SYSLand',
          AssociatedComponentName: 'Land',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        LeverantorsLand: {
          AssociationName: 'LeverantorsLand',
          DisplayLabel: 'Leverantörsland',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'SYSLand',
          AssociatedComponentName: 'Land',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Orderkategori: {
          AssociationName: 'Orderkategori',
          DisplayLabel: 'Orderkategori',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'OFOrderkategori',
          AssociatedComponentName: 'Orderkategori',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Kremation: {
          AssociationName: 'Kremation',
          DisplayLabel: 'Kremation',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'KJTEDKJKremationOrder',
          AssociatedComponentName: 'KremationOrder',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        FaktureringsLand: {
          AssociationName: 'FaktureringsLand',
          DisplayLabel: 'Faktureringsland',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'SYSLand',
          AssociatedComponentName: 'Land',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Orderunderlag: {
          AssociationName: 'Orderunderlag',
          DisplayLabel: 'Orderunderlag',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'OFOrderunderlag',
          AssociatedComponentName: 'Orderunderlag',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Gravplats: {
          AssociationName: 'Gravplats',
          DisplayLabel: 'Gravplats',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'GAGrav',
          AssociatedComponentName: 'Grav',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Bisattning: {
          AssociationName: 'Bisattning',
          DisplayLabel: 'Bisättning',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'BOTEDBOBisattningOrder',
          AssociatedComponentName: 'BisattningOrder',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        RegistreratAv: {
          AssociationName: 'RegistreratAv',
          DisplayLabel: 'RegistreratAv',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'SYSUser',
          AssociatedComponentName: 'User',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Periodordermall: {
          AssociationName: 'Periodordermall',
          DisplayLabel: 'Periodorder, mall',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'OFOrder',
          AssociatedComponentName: 'Order',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        KonvFranPeriodMall: {
          AssociationName: 'KonvFranPeriodMall',
          DisplayLabel: 'Konverterad från periodmall',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'OFOrder',
          AssociatedComponentName: 'Order',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Orderrader: {
          AssociationName: 'Orderrader',
          DisplayLabel: 'Orderrader',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'OFOrderrad',
          AssociatedComponentName: 'Orderrad',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        Fakturor: {
          AssociationName: 'Fakturor',
          DisplayLabel: 'Fakturor',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'KRFaktura',
          AssociatedComponentName: 'Faktura',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        Ordermoms: {
          AssociationName: 'Ordermoms',
          DisplayLabel: 'Ordermoms',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'OFOrderMoms',
          AssociatedComponentName: 'Ordermoms',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Bilagor: {
          AssociationName: 'Bilagor',
          DisplayLabel: 'Bilagor',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'OFOrderBilaga',
          AssociatedComponentName: 'OrderBilaga',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        Periodordrar: {
          AssociationName: 'Periodordrar',
          DisplayLabel: 'Periodordrar',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'OFOrder',
          AssociatedComponentName: 'Order',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    OFPrisavtal: {
      CollectionName: 'OFPrisavtal',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'Prisavtal',
        Abstract: false,
        SOLabel: 'Prisavtal',
        SOGLabel: 'Prisavtal',
        SBLabel: 'Prisavtalet',
        SBGLabel: 'Prisavtalet',
        POLabel: 'Prisavtal',
        POGLabel: 'Prisavtal',
        PBLabel: 'Prisavtalen',
        PBGLabel: 'Prisavtalen',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Prisavtalet primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Prisavtalet versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Prisavtalet id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Prisavtalet fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BENAMNING: {
          AttributeName: 'BENAMNING',
          DisplayLabel: 'Benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 30,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        FRANDATUM: {
          AttributeName: 'FRANDATUM',
          DisplayLabel: 'Fråndatum',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          FormatterValidateParams: 'MaxDate="+72m";MinDate="-144m";MaxRecommendedDate="+12m";MinRecommendedDate="-12m"',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          Required: true,
        },
        TILLDATUM: {
          AttributeName: 'TILLDATUM',
          DisplayLabel: 'Tilldatum',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          FormatterValidateParams: 'MaxDate="+72m";MinDate="-144m";MaxRecommendedDate="+24m";MinRecommendedDate="-12m"',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        Prisavtalrader_ArtikelnrGrupp: {
          AttributeName: 'Prisavtalrader_ArtikelnrGrupp',
          DisplayLabel: 'Artikelnr/grupp',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        PrisavtalRader: {
          AssociationName: 'PrisavtalRader',
          DisplayLabel: 'PrisavtalRader',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'OFPrisavtalRad',
          AssociatedComponentName: 'Prisavtalsrader',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        Prisavtalkund: {
          AssociationName: 'Prisavtalkund',
          DisplayLabel: 'Prisavtalkund',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'OFTEDOFPrisavtalKund',
          AssociatedComponentName: 'PrisavtalKund',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    OFTEDOFPrisavtalKund: {
      CollectionName: 'OFTEDOFPrisavtalKund',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'PrisavtalKund',
        Abstract: false,
        SOLabel: 'Prisavtal för kund',
        SOGLabel: 'Prisavtal för kund',
        SBLabel: 'Prisavtal för kunden',
        SBGLabel: 'Prisavtal för kunden',
        POLabel: 'Prisavtal för kunder',
        POGLabel: 'Prisavtal för kunder',
        PBLabel: 'Prisavtal för kunderna',
        PBGLabel: 'Prisavtal för kunderna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Prisavtal för kunden primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Prisavtal för kunden versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Prisavtal för kunden fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Kundnr2: {
          AttributeName: 'Kundnr2',
          DisplayLabel: 'Kundnr',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KundNamn: {
          AttributeName: 'KundNamn',
          DisplayLabel: 'Kundens namn',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KundNamnAdress: {
          AttributeName: 'KundNamnAdress',
          DisplayLabel: 'Kundens namn och adress',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        Kund_Adressrad: {
          AttributeName: 'Kund_Adressrad',
          DisplayLabel: 'Kundens adressrad',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Prisavtal: {
          AttributeName: 'Prisavtal',
          DisplayLabel: 'Prisavtal',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Prisavtal_Frandatum: {
          AttributeName: 'Prisavtal_Frandatum',
          DisplayLabel: 'Prisavtalets fråndatum',
          DataType: 'DateTime',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Prisavtal_Tilldatum2: {
          AttributeName: 'Prisavtal_Tilldatum2',
          DisplayLabel: 'Prisavtalets tilldatum',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Kund: {
          AssociationName: 'Kund',
          DisplayLabel: 'Kund',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'KRKund',
          AssociatedComponentName: 'Kund',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([['NOT_ATAGANDE', 'True']]),
          Required: true,
        },
        Prisavtal: {
          AssociationName: 'Prisavtal',
          DisplayLabel: 'Prisavtal',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'OFPrisavtal',
          AssociatedComponentName: 'Prisavtal',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
          Required: true,
        },
        Prisavtalsrader: {
          AssociationName: 'Prisavtalsrader',
          DisplayLabel: 'Prisavtalsrader',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'OFPrisavtalRad',
          AssociatedComponentName: 'Prisavtalsrader',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    OFPrisavtalRad: {
      CollectionName: 'OFPrisavtalRad',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'Prisavtalsrader',
        Abstract: true,
        SOLabel: 'Prisavtalsrad',
        SOGLabel: 'Prisavtalsrad',
        SBLabel: 'Prisavtalsraden',
        SBGLabel: 'Prisavtalsraden',
        POLabel: 'Prisavtalsrader',
        POGLabel: 'Prisavtalsrader',
        PBLabel: 'Prisavtalsraderna',
        PBGLabel: 'Prisavtalsraderna',
        Visible: true,
        ChildTypes: [
          {
            TypeValue: 'PAvtArtikel',
            Abstract: false,
            SOLabel: 'Prisavtal artikel',
            SOGLabel: 'Prisavtal artikel',
            SBLabel: 'Prisavtal artikeln',
            SBGLabel: 'Prisavtal artikeln',
            POLabel: 'Prisavtal artiklar',
            POGLabel: 'Prisavtal artiklar',
            PBLabel: 'Prisavtal artiklarna',
            PBGLabel: 'Prisavtal artiklarna',
            Visible: true,
            ChildTypes: [
            ],
          },
          {
            TypeValue: 'PAvtArtikelgrupp',
            Abstract: false,
            SOLabel: 'Prisavtal artikelgrupp',
            SOGLabel: 'Prisavtal artikelgrupp',
            SBLabel: 'Prisavtal artikelgruppen',
            SBGLabel: 'Prisavtal artikelgruppen',
            POLabel: 'Prisavtal artikelgrupper',
            POGLabel: 'Prisavtal artikelgrupper',
            PBLabel: 'Prisavtal artikelgrupperna',
            PBGLabel: 'Prisavtal artikelgrupperna',
            Visible: true,
            ChildTypes: [
            ],
          },
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Prisavtalsraden primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Prisavtalsraden versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _typ: {
          AttributeName: '_typ',
          DisplayLabel: 'Typ',
          DataType: 'Enum',
          EnumValues: new Map([['PAVTARTIKEL', 'Prisavtal artikel'], ['PAVTARTIKELGRUPP', 'Prisavtal artikelgrupp']]),
          EnumSortValues: new Map([['PAVTARTIKEL', 'A'], ['PAVTARTIKELGRUPP', 'G']]),
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifTypeTree',
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Prisavtalsraden fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        RABATT: {
          AttributeName: 'RABATT',
          DisplayLabel: 'Rabatt',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatIntAsPercent',
          FormatterParseParams: 'Decimals="0"',
          FormatterDisplayParams: 'Decimals="0"',
          FormatterValidateParams: 'MinValue="0"',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.notless,
        },
        ArtikelnrGrupp: {
          AttributeName: 'ArtikelnrGrupp',
          DisplayLabel: 'Artikelnr/ArtikelGrupp',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ArtikelGruppBenamning: {
          AttributeName: 'ArtikelGruppBenamning',
          DisplayLabel: 'Artikel/Artikelgrupp benämning',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ARTIKEL_ID: {
          AttributeName: 'ARTIKEL_ID',
          DisplayLabel: 'Artikel',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['PAvtArtikel'],
        },
        PRIS: {
          AttributeName: 'PRIS',
          DisplayLabel: 'Pris',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatCurr',
          FormatterValidateParams: 'MinValue="0"',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          ValidInComps: ['PAvtArtikel'],
        },
        Artikelnr: {
          AttributeName: 'Artikelnr',
          DisplayLabel: 'Artikelnr',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          ValidInComps: ['PAvtArtikel'],
        },
        Artikelnr2: {
          AttributeName: 'Artikelnr2',
          DisplayLabel: 'Artikelnr',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['PAvtArtikel'],
        },
        Artikelbenamning2: {
          AttributeName: 'Artikelbenamning2',
          DisplayLabel: 'Artikelbenämning',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['PAvtArtikel'],
        },
        ARTIKELGRUPP_ID: {
          AttributeName: 'ARTIKELGRUPP_ID',
          DisplayLabel: 'Artikelgrupp',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
          ValidInComps: ['PAvtArtikelgrupp'],
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Artikel: {
          AssociationName: 'Artikel',
          DisplayLabel: 'Artikel',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'LAArtikel',
          AssociatedComponentName: 'Artikel',
          JoinAssociation: true,
          ValidInComps: ['PAvtArtikel'],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Artikelgrupp: {
          AssociationName: 'Artikelgrupp',
          DisplayLabel: 'Artikelgrupp',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'LAArtikelgrupp',
          AssociatedComponentName: 'Artikelgrupp',
          JoinAssociation: true,
          ValidInComps: ['PAvtArtikelgrupp'],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    OFRanteomgang: {
      CollectionName: 'OFRanteomgang',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'Ranteomgang',
        Abstract: false,
        SOLabel: 'Ränteomgång',
        SOGLabel: 'Ränteomgång',
        SBLabel: 'Ränteomgången',
        SBGLabel: 'Ränteomgången',
        POLabel: 'Ränteomgångar',
        POGLabel: 'Ränteomgångar',
        PBLabel: 'Ränteomgångarna',
        PBGLabel: 'Ränteomgångarna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Ränteomgången primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Ränteomgången versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Ränteomgången id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Ränteomgången fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        RUBRIK: {
          AttributeName: 'RUBRIK',
          DisplayLabel: 'Rubrik',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 30,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        STATUS: {
          AttributeName: 'STATUS',
          DisplayLabel: 'Status',
          Hint: 'Skapad/Backad',
          DataType: 'Enum',
          EnumValues: new Map([['SKAPAD', 'Skapad'], ['BACKAD', 'Backad']]),
          EnumSortValues: new Map([['SKAPAD', 'S'], ['BACKAD', 'B']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SKAPAD=Skapad;BACKAD=Backad"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          Required: true,
        },
        DATUM_SKAPAD: {
          AttributeName: 'DATUM_SKAPAD',
          DisplayLabel: 'Skapad datum',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        SIGN_SKAPAD: {
          AttributeName: 'SIGN_SKAPAD',
          DisplayLabel: 'Skapad av',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        DATUM_BACKAD: {
          AttributeName: 'DATUM_BACKAD',
          DisplayLabel: 'Backad datum',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        SIGN_BACKAD: {
          AttributeName: 'SIGN_BACKAD',
          DisplayLabel: 'Backad av',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        Status2: {
          AttributeName: 'Status2',
          DisplayLabel: 'Status',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        StatusBen: {
          AttributeName: 'StatusBen',
          DisplayLabel: 'Status',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Ordrar: {
          AssociationName: 'Ordrar',
          DisplayLabel: 'Ränteorder',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'OFOrder',
          AssociatedComponentName: 'Direktorder',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    OFSaljare: {
      CollectionName: 'OFSaljare',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'Saljare',
        Abstract: false,
        SOLabel: 'Säljare',
        SOGLabel: 'Säljare',
        SBLabel: 'Säljaren',
        SBGLabel: 'Säljaren',
        POLabel: 'Säljare',
        POGLabel: 'Säljare',
        PBLabel: 'Säljarna',
        PBGLabel: 'Säljarna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Säljaren primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Säljaren versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Säljaren id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Säljaren fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        NAMN: {
          AttributeName: 'NAMN',
          DisplayLabel: 'Namn',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 20,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          Required: true,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Order: {
          AssociationName: 'Order',
          DisplayLabel: 'Order',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'OFOrder',
          AssociatedComponentName: 'Order',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
  },
};

export default OF;
